const FREE_GIFT_PROPERTY = "_naomi_free_gift";
const FREE_GIFT_TYPE_PROPERTY = "_naomi_gift_type";
const FREE_GIFT_REMOVED_KEY = "naomi-free-gift-removed";
const SCRUB_GIFT_REMOVED_KEY = "naomi-scrub-gift-removed";
const FREE_GIFT_PRODUCT_ID = 7947797921910;
const FREE_GIFT_VARIANT_ID = "43005880664182";
const PAID_HAT_PRODUCT_ID = 7676467839094;
const SCRUB_GIFT_PRODUCT_ID = 8289639628918;
const SCRUB_GIFT_VARIANT_ID = "44141199917174";
const SCRUB_GIFT_VISIBLE_THRESHOLD = 12000;
const SCRUB_GIFT_THRESHOLD = 22000;
const PAID_NO_FRAGRANCE_PRODUCT_ID = 7631726084214;
const DEFAULT_FREE_SHIPPING_THRESHOLD = 6000;
const QUANTITY_CHANGE_DEBOUNCE_MS = 275;
const QUANTITY_RENDER_SETTLE_MS = 450;
const EXTERNAL_ADD_FAST_REFRESH_MS = 80;
const EXTERNAL_ADD_BACKUP_REFRESH_MS = 1400;
const EXTERNAL_ADD_ANTICIPATION_MS = 1800;
const CART_FADE_VISIBILITY_BUFFER_PX = 14;
const MANUAL_CLOSE_REOPEN_SUPPRESS_MS = 2400;
const LINE_QUANTITY_INTENT_MAX_AGE_MS = 6000;
const LEGACY_UPCART_REWARD_PRODUCT_PROPERTY = "__upcartRewardProduct";
const LEGACY_UPCART_FREE_GIFT_PROPERTY = "__upcartFreeGift";
const REWARD_TIER_ORDER = { shipping: 0, hat: 1, scrub: 2 };

const state = {
  carouselInteracted: false,
  closeTimer: undefined,
  drawerOpenedAt: 0,
  externalAddNoOpenUntil: 0,
  externalAddRefreshTimers: new Map(),
  closingChoreographyTimer: undefined,
  giftUnlockTimer: undefined,
  internalRequestDepth: 0,
  isRefreshing: false,
  giftQualifyingSubtotal: undefined,
  latestExternalAddKey: undefined,
  optimisticGiftUnlockShown: false,
  optimisticScrubGiftUnlockShown: false,
  nextCartAddProduct: undefined,
  openingChoreographyTimer: undefined,
  pendingGiftUnlockMoment: false,
  rewardMessageTimer: undefined,
  subscriptionInfoOpenedAt: 0,
  subscriptionInfoLayerTimers: [],
  wasBelowGiftThreshold: undefined,
  wasBelowScrubGiftThreshold: undefined,
  cartMutationSeq: 0,
  closedExternalAddKeys: new Set(),
  confirmedItemCount: undefined,
  lastCart: undefined,
  lineChangeTimers: new Map(),
  manualCartClosedUntil: 0,
  pendingExternalAddProducts: new Map(),
  pendingAnticipatedExternalAdds: [],
  pendingGiftUnlockType: undefined,
  pendingLineQuantityIntents: new Map(),
  optimisticMergedAddKeys: new Set(),
  pendingCartCountDeltas: new Map(),
  pendingCartCountTargets: new Map(),
  pendingCartCountSeq: 0,
  pendingLineChangeRequests: 0,
  lineChangeInFlight: new Set(),
  lineChangeLatestRequests: new Map(),
  cartViewportHeight: undefined,
  cartViewportTop: undefined,
  prewarmPromise: undefined,
  prewarmTimer: undefined,
  quantitySettledAt: 0,
  refreshTimer: undefined,
  refreshPromise: undefined,
  silentGiftValidationPromise: undefined,
  silentGiftValidationTimer: undefined,
  cartTouchLastY: undefined,
  cartLayoutFrame: undefined,
  cartTouchStartX: undefined,
  cartTouchStartY: undefined,
  touchStartX: undefined,
};

function shopifyRoot() {
  return window.Shopify?.routes?.root || "/";
}

function endpoint(path) {
  return `${shopifyRoot()}${path}`.replace(/\/{2,}/g, "/");
}

function getRoot() {
  return document.querySelector("[data-naomi-cart]");
}

function getDialog() {
  return document.body?.querySelector("[data-naomi-cart-dialog]") || document.querySelector("[data-naomi-cart-dialog]");
}

function getConfig() {
  const root = getRoot();
  const freeGiftThreshold = Number(root?.dataset.freeGiftThreshold || 12000);

  return {
    freeGiftProductId: Number(root?.dataset.freeGiftProductId || FREE_GIFT_PRODUCT_ID),
    freeGiftThreshold,
    freeGiftVariantId: root?.dataset.freeGiftVariantId || FREE_GIFT_VARIANT_ID,
    sectionId: root?.dataset.sectionId || "header",
    scrubGiftImage: root?.dataset.scrubGiftImage,
    scrubGiftProductId: Number(root?.dataset.scrubGiftProductId || SCRUB_GIFT_PRODUCT_ID),
    scrubGiftThreshold: Number(root?.dataset.scrubGiftThreshold || SCRUB_GIFT_THRESHOLD),
    scrubGiftTitle: root?.dataset.scrubGiftTitle || "Free After-Cooking Hand Scrub",
    scrubGiftVariantId: root?.dataset.scrubGiftVariantId || SCRUB_GIFT_VARIANT_ID,
    scrubGiftVisibleThreshold: freeGiftThreshold,
  };
}

function confirmedItemCountFromDom() {
  const rootCount = Number(getRoot()?.dataset.cartItemCount);
  if (Number.isFinite(rootCount)) return rootCount;

  const bubbleCount = Number(document.querySelector("cart-icon .cart-bubble__text-count")?.textContent || 0);
  return Number.isFinite(bubbleCount) ? bubbleCount : 0;
}

function centsFromDataset(element, key) {
  const value = Number(element?.dataset?.[key]);
  return Number.isFinite(value) ? value : 0;
}

function activeCurrencyCode(root = getRoot()) {
  return root?.dataset.cartCurrency || window.Shopify?.currency?.active || "USD";
}

function activeCurrencyRate() {
  const rate = Number(window.Shopify?.currency?.rate);
  return Number.isFinite(rate) && rate > 0 ? rate : 1;
}

function freeShippingThreshold(root = getRoot()) {
  const configuredThreshold = Number(root?.dataset.freeShippingThreshold || DEFAULT_FREE_SHIPPING_THRESHOLD);
  const sourceCurrency = root?.dataset.freeShippingSourceCurrency || "";
  const currentCurrency = activeCurrencyCode(root);

  if (sourceCurrency && currentCurrency && sourceCurrency !== currentCurrency) {
    return Math.round(configuredThreshold * activeCurrencyRate());
  }

  return configuredThreshold;
}

function isCanadaMarket(root = getRoot()) {
  return root?.dataset.marketCountry === "CA" || activeCurrencyCode(root) === "CAD";
}

function formatCartMoney(cents) {
  const roundedCents = Math.round(Math.max(0, Number(cents) || 0));
  const amount = roundedCents / 100;
  const currency = activeCurrencyCode();
  const locale = window.Shopify?.locale || document.documentElement.lang || "en-US";
  const hasCents = roundedCents % 100 !== 0;

  if (currency === "CAD") {
    return `$${amount.toFixed(hasCents ? 2 : 0)}`;
  }

  try {
    return new Intl.NumberFormat(locale, {
      currency,
      maximumFractionDigits: hasCents ? 2 : 0,
      minimumFractionDigits: hasCents ? 2 : 0,
      style: "currency",
    }).format(amount);
  } catch (error) {
    return `$${amount.toFixed(hasCents ? 2 : 0)}`;
  }
}

function formatCheckoutMoney(cents) {
  const amount = formatCartMoney(cents);
  return activeCurrencyCode() === "CAD" ? `${amount} CAD` : amount;
}

function prefersReducedMotion() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
}

function updateCheckoutAmount(root, cartTotal, { animate = true } = {}) {
  const checkoutAmount =
    root?.querySelector(".naomi-cart__checkout-amount") || root?.querySelector(".naomi-cart__checkout span:last-child");
  if (!(checkoutAmount instanceof HTMLElement)) return;

  const nextText = formatCheckoutMoney(cartTotal);
  if (checkoutAmount.textContent === nextText) return;

  window.clearTimeout(Number(checkoutAmount.dataset.naomiCheckoutAmountTimer || 0));

  if (!animate || prefersReducedMotion()) {
    checkoutAmount.textContent = nextText;
    checkoutAmount.classList.remove("is-updating");
    delete checkoutAmount.dataset.naomiCheckoutAmountTimer;
    return;
  }

  checkoutAmount.classList.add("is-updating");
  const timer = window.setTimeout(() => {
    checkoutAmount.textContent = nextText;
    checkoutAmount.classList.remove("is-updating");
    delete checkoutAmount.dataset.naomiCheckoutAmountTimer;
  }, 90);
  checkoutAmount.dataset.naomiCheckoutAmountTimer = String(timer);
}

function optimisticRecommendationShimmerHtml() {
  return `
    <section class="naomi-cart__recommendations naomi-cart__recommendations--pending is-stacked" aria-label="Recommended products" data-naomi-recommendations>
      <div class="naomi-cart__recommendation-head">
        <span class="naomi-cart__pending-block naomi-cart__pending-recommendation-heading" aria-label="Loading recommendation heading"></span>
      </div>
      <div class="naomi-cart__recommendation-stage">
        <article class="naomi-cart__recommendation-card is-active" aria-label="Loading recommendation" data-naomi-recommendation-card>
          <span class="naomi-cart__recommendation-image" aria-hidden="true">
            <span class="naomi-cart__pending-block naomi-cart__pending-image"></span>
          </span>
          <div class="naomi-cart__recommendation-main">
            <div>
              <span class="naomi-cart__pending-block naomi-cart__pending-title"></span>
              <span class="naomi-cart__pending-block naomi-cart__pending-meta"></span>
            </div>
            <span class="naomi-cart__pending-block naomi-cart__pending-price"></span>
          </div>
        </article>
        <article class="naomi-cart__recommendation-card" aria-label="Loading recommendation" data-naomi-recommendation-card>
          <span class="naomi-cart__recommendation-image" aria-hidden="true">
            <span class="naomi-cart__pending-block naomi-cart__pending-image"></span>
          </span>
          <div class="naomi-cart__recommendation-main">
            <div>
              <span class="naomi-cart__pending-block naomi-cart__pending-title"></span>
              <span class="naomi-cart__pending-block naomi-cart__pending-meta"></span>
            </div>
            <span class="naomi-cart__pending-block naomi-cart__pending-price"></span>
          </div>
        </article>
      </div>
    </section>
  `;
}

function optimisticCartBottomHtml(cartTotal) {
  return `
    <div class="naomi-cart__bottom" data-naomi-optimistic-bottom="true">
      ${optimisticRecommendationShimmerHtml()}
      <footer class="naomi-cart__foot">
        <a class="naomi-cart__checkout" href="${endpoint("checkout")}">
          <span>Check out</span><span class="naomi-cart__checkout-separator" aria-hidden="true">&bull;</span><span class="naomi-cart__checkout-amount">${formatCheckoutMoney(cartTotal)}</span>
        </a>
        <p class="naomi-cart__foot-note">
          <span>Subtotal &bull; Cancel subscriptions anytime</span>
          <button class="naomi-cart__subscription-info" type="button" aria-label="Subscription details" data-naomi-subscription-info>?</button>
        </p>
      </footer>
    </div>
  `;
}

function ensureOptimisticCartBottom(root = getRoot(), cartTotal = centsFromDataset(root, "cartTotal")) {
  if (!root || cartTotal <= 0) return undefined;

  const existingBottom = root.querySelector(".naomi-cart__bottom");
  if (existingBottom instanceof HTMLElement) return existingBottom;

  root.insertAdjacentHTML("beforeend", optimisticCartBottomHtml(cartTotal));
  return root.querySelector(".naomi-cart__bottom");
}

function compactText(value = "") {
  return String(value).replace(/\s+/g, " ").trim();
}

function centsFromMoneyText(value = "") {
  const match = compactText(value).replace(/,/g, "").match(/\$\s*(\d+(?:\.\d{1,2})?)/);
  if (!match) return undefined;

  const amount = Number(match[1]);
  return Number.isFinite(amount) ? Math.round(amount * 100) : undefined;
}

function firstValidCents(...values) {
  return values.find((value) => Number.isFinite(value) && value >= 0);
}

function centsFromPurchaseOptionText(value = "", wantsSubscription = false) {
  const text = compactText(value).replace(/,/g, "");
  const subscriptionControlsAreOpen = /cancel anytime|Every\s+2\s+months|Every\s+3\s+months|Every\s+6\s+months/i.test(text);

  if (wantsSubscription || subscriptionControlsAreOpen) {
    const subscriptionMatch = text.match(/Subscribe(?:\s*&\s*save)?\s*\$?\s*(\d+(?:\.\d{1,2})?)/i);
    if (subscriptionMatch) return Math.round(Number(subscriptionMatch[1]) * 100);
  } else {
    const oneTimeMatch = text.match(/One\s*time\s*\$?\s*(\d+(?:\.\d{1,2})?)/i);
    if (oneTimeMatch) return Math.round(Number(oneTimeMatch[1]) * 100);
  }

  return undefined;
}

function centsFromPurchaseOptionContext(control, payload = {}, boundary) {
  const wantsSubscription = Boolean(payload.sellingPlan);
  const boundaryPrice = centsFromPurchaseOptionText(boundary?.innerText || boundary?.textContent || "", wantsSubscription);
  if (boundaryPrice !== undefined) return boundaryPrice;

  let node = control?.parentElement;

  while (node && node instanceof Element) {
    const price = centsFromPurchaseOptionText(node.innerText || node.textContent || "", wantsSubscription);
    if (price !== undefined) return price;

    if (node.matches("[data-replo-product-container], [data-replo-product-handle]")) break;
    node = node.parentElement;
  }

  return undefined;
}

function mergeProductContext(base = {}, overlay = {}) {
  return Object.entries(overlay).reduce((product, [key, value]) => {
    if (value !== undefined && value !== "" && value !== null) product[key] = value;
    return product;
  }, { ...base });
}

function cleanOptimisticProductTitle(value = "") {
  const title = compactText(value);
  if (!title || title.length > 90 || /^(null|undefined|false|true|refill)$/i.test(title)) return undefined;
  if (
    /purchase options|subscription details|how subscriptions work|one-time purchase|deliver every|subscribe\s*&?\s*save|\bcancel\b|learn more about subscriptions/i.test(
      title,
    )
  ) {
    return undefined;
  }

  return title;
}

function cleanOptimisticProductSubtitle(value = "") {
  const subtitle = compactText(value);
  if (
    !subtitle ||
    subtitle.length > 70 ||
    /^(null|undefined|false|true|•|anytime|monthly|month|months|every\s+\d+\s+months?)$/i.test(subtitle)
  ) {
    return undefined;
  }
  if (
    /^\$/.test(subtitle) ||
    /^(add|pre-order|save|one time|one-time|subscribe|cancel|purchase options|subscription details|how subscriptions work|deliver every|learn more|reviews?)\b/i.test(
      subtitle,
    )
  ) {
    return undefined;
  }

  return subtitle;
}

function optimisticProductFromHandle(handle) {
  const product = {
    "bergamot_scrub": {
      image: "https://assets.replocdn.com/projects/7386dcde-336a-4267-886a-176cadf1495b/e2d53d18-b47a-442c-bf68-6c0d6f572433?width=900",
      isSubscribable: true,
      subtitle: "Bergamot & Pepper",
      title: "After-Cooking Hand Scrub",
    },
    "santal_scrub": {
      image: "https://trynaomi.com/cdn/shop/files/Square_Shiso.png?v=1786840713&width=900",
      isSubscribable: true,
      subtitle: "Santal & Shiso",
      title: "After-Cooking Hand Scrub",
    },
    "wood-yuzu-scrub": {
      image: "https://trynaomi.com/cdn/shop/files/Square_wood.png?v=1786840657&width=900",
      isSubscribable: true,
      subtitle: "Wood & Yuzu",
      title: "After-Cooking Hand Scrub",
    },
    "no_fragrance_scrub": {
      image: "https://trynaomi.com/cdn/shop/files/No_Fragrance_Square.png?v=1786840831&width=900",
      isSubscribable: true,
      subtitle: "No Fragrance",
      title: "After-Cooking Hand Scrub",
    },
    "los-angeles": {
      image: "https://trynaomi.com/cdn/shop/files/Square_bright.png?v=1788002589&width=900",
      isSubscribable: true,
      subtitle: "Aromatic Hand Wash",
      title: "Los Angeles Terroir",
    },
    "los-angeles-terroir-refill": {
      image: "https://trynaomi.com/cdn/shop/files/Naomi_June_2025_Shot_by_Direction_Bureaux_Web_Res-03_1_e5798ba1-2d5f-4bc4-9a15-bab6da39217b.png?v=1777161651&width=900",
      isSubscribable: true,
      subtitle: "Aromatic Hand Wash",
      title: "Los Angeles Terroir Refill",
    },
    "santal-shiso-refill": {
      image: "https://trynaomi.com/cdn/shop/files/Shiso_Square.png?v=1786844935&width=900",
      isSubscribable: true,
      subtitle: "Santal & Shiso",
      title: "After-Cooking Hand Scrub Refill",
    },
    "wood-yuzu-refill": {
      image: "https://trynaomi.com/cdn/shop/files/Yuzu_Pouch_Square.png?v=1786843895&width=900",
      isSubscribable: true,
      subtitle: "Wood & Yuzu",
      title: "After-Cooking Hand Scrub Refill",
    },
    "la-terroir-candle": {
      image: "https://trynaomi.com/cdn/shop/files/Candle_Square_perfect.png?v=1786839152&width=900",
      isSubscribable: true,
      subtitle: "Aromatic Candle",
      title: "Los Angeles Terroir",
    },
    "cooking-stinks-hat": {
      image: "https://trynaomi.com/cdn/shop/files/IMG_1419_eeb03e99-43e1-482e-9802-377a0ef4b504.jpg?v=1769201882&width=900",
      title: "Cooking Stinks Dad Hat",
    },
    "cooking-stinks-dad-hat-gift": {
      image: "https://trynaomi.com/cdn/shop/files/IMG_1419_eeb03e99-43e1-482e-9802-377a0ef4b504.jpg?v=1769201882&width=900",
      subtitle: "Cooking Stinks",
      title: "Free Dad Hat",
    },
  }[handle];

  if (!product) return {};

  return {
    image: absoluteImageUrl(product.image),
    isSubscribable: Boolean(product.isSubscribable),
    subtitle: cleanOptimisticProductSubtitle(product.subtitle),
    title: cleanOptimisticProductTitle(product.title),
  };
}

function visibleTextFragments(container, exclude) {
  if (!container || typeof document.createTreeWalker !== "function") return [];

  const filter = window.NodeFilter || { FILTER_ACCEPT: 1, FILTER_REJECT: 2, SHOW_TEXT: 4 };
  const fragments = [];
  const walker = document.createTreeWalker(container, filter.SHOW_TEXT, {
    acceptNode(node) {
      const element = node.parentElement;
      if (!element || exclude?.contains(element)) return filter.FILTER_REJECT;
      if (element.closest("script, style, noscript, [data-naomi-cart-dialog], [data-replo-add-product-variant-to-cart], form[action*='/cart/add'], .kaching-bundles__block")) {
        return filter.FILTER_REJECT;
      }

      const style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden") return filter.FILTER_REJECT;
      if (element.getClientRects().length === 0) return filter.FILTER_REJECT;

      return compactText(node.textContent) ? filter.FILTER_ACCEPT : filter.FILTER_REJECT;
    },
  });

  while (walker.nextNode()) {
    const fragment = cleanOptimisticProductSubtitle(walker.currentNode.textContent);
    if (fragment && !fragments.includes(fragment)) fragments.push(fragment);
  }

  return fragments;
}

function imageFromClosestContext(control, boundary) {
  let node = control;
  while (node && node instanceof Element) {
    const image = node.querySelector?.("img");
    if (image) return image;
    if (node === boundary) break;
    node = node.parentElement;
  }

  return boundary?.querySelector?.("img");
}

function currentProductHandle() {
  return window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
}

function productHandleFromUrl(url) {
  if (!url) return undefined;

  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  } catch (error) {
    return String(url).match(/\/products\/([^/?#]+)/)?.[1];
  }
}

function productHandleFromLink(container) {
  const link =
    container?.matches?.("a[href*='/products/']")
      ? container
      : container?.querySelector?.("a[href*='/products/']");

  return productHandleFromUrl(link?.getAttribute?.("href"));
}

function isScopedProductContext(container) {
  if (!container) return false;

  const text = compactText(container.innerText || container.textContent || "");
  if (text.length > 420) return false;

  const handles = new Set(
    [...container.querySelectorAll("a[href*='/products/']")]
      .map((link) => productHandleFromUrl(link.getAttribute("href")))
      .filter(Boolean),
  );
  if (handles.size > 1) return false;

  const images = container.querySelectorAll("img").length;
  if (images > 2 && handles.size === 0) return false;

  return true;
}

function productHandleFromCardText(card) {
  const text = compactText(card?.innerText || card?.textContent || "").toLowerCase();
  if (!text) return undefined;

  if (text.includes("candle")) return "la-terroir-candle";

  if (text.includes("refill")) {
    if (text.includes("los angeles") || currentProductHandle() === "los-angeles") return "los-angeles-terroir-refill";
    if (text.includes("santal") || text.includes("shiso") || currentProductHandle() === "santal_scrub") return "santal-shiso-refill";
    if (text.includes("wood") || text.includes("yuzu") || currentProductHandle() === "wood-yuzu-scrub") return "wood-yuzu-refill";
  }

  if (text.includes("los angeles terroir")) return "los-angeles";
  if (text.includes("no fragrance") || text.includes("fragrance-free")) return "no_fragrance_scrub";
  if (text.includes("wood") && text.includes("yuzu")) return "wood-yuzu-scrub";
  if (text.includes("santal") && text.includes("shiso")) return "santal_scrub";
  if (text.includes("bergamot") && text.includes("pepper")) return "bergamot_scrub";

  return undefined;
}

function productImageUrlFromData(product) {
  const image =
    product?.image ||
    product?.featured_image ||
    product?.featuredImage ||
    product?.images?.[0] ||
    product?.media?.find?.((item) => item?.src || item?.url || item?.preview_image)?.preview_image;
  const url = typeof image === "string" ? image : image?.src || image?.url;

  if (!url) return undefined;
  if (url.startsWith("//")) return `${window.location.protocol}${url}`;
  return url;
}

function absoluteImageUrl(url) {
  if (!url) return undefined;
  if (url.startsWith("//")) return `${window.location.protocol}${url}`;

  try {
    return new URL(url, window.location.origin).href;
  } catch (error) {
    return url;
  }
}

function pageProductImageUrl() {
  const selector = [
    'meta[property="og:image:secure_url"]',
    'meta[property="og:image"]',
    'meta[name="twitter:image"]',
  ].join(", ");
  const metaImage = document.querySelector(selector)?.getAttribute("content");
  if (metaImage) return absoluteImageUrl(metaImage);

  const visibleMediaImage = [...document.querySelectorAll("main img, [role='main'] img, product-media img, media-gallery img")]
    .find((image) => image instanceof HTMLImageElement && !image.closest("form[action*='/cart/add'], [data-naomi-cart-dialog]") && image.currentSrc);

  return absoluteImageUrl(visibleMediaImage?.currentSrc || visibleMediaImage?.src);
}

function optimisticImageUrl({ card, handle, image, productData, handleProduct, preferHandleImage = false } = {}) {
  const handleImage = absoluteImageUrl(handleProduct?.image);
  const productDataImage = productImageUrlFromData(productData);
  if (preferHandleImage || (handle && handle === currentProductHandle() && !card)) {
    return handleImage || productDataImage || pageProductImageUrl() || absoluteImageUrl(image?.currentSrc || image?.src);
  }

  return absoluteImageUrl(image?.currentSrc || image?.src) || handleImage || productDataImage || pageProductImageUrl();
}

function optimisticTitleFromProductData(product) {
  const title = cleanOptimisticProductTitle(product?.title);
  if (!title) return {};

  if (title.includes(":")) {
    const [main, ...subtitleParts] = title.split(":");
    return {
      subtitle: cleanOptimisticProductSubtitle(subtitleParts.join(":")),
      title: cleanOptimisticProductTitle(main),
    };
  }

  return { title };
}

function productDataHasSellingPlans(product) {
  return Boolean(
    product?.requires_selling_plan ||
      product?.requiresSellingPlan ||
      product?.selling_plan_groups?.length ||
      product?.sellingPlanGroups?.length ||
      product?.variants?.some?.((variant) => (
        variant?.selling_plan_allocations?.length ||
        variant?.sellingPlanAllocations?.length ||
        variant?.selling_plan_groups?.length ||
        variant?.sellingPlanGroups?.length
      )),
  );
}

function embeddedProductDataForHandle(handle) {
  if (!handle) return undefined;

  for (const script of document.querySelectorAll('script[type="application/json"], script:not([type])')) {
    const text = script.textContent || "";
    if (!text.includes('"handle"') || !text.includes(handle)) continue;

    try {
      const data = JSON.parse(text);
      const products = Array.isArray(data) ? data : data.products || data.items || (data.handle ? [data] : []);
      const product = products.find?.((candidate) => candidate?.handle === handle);
      if (product) return product;
      if (data.handle === handle) return data;
    } catch (error) {
      const match = text.match(new RegExp(`\\{[^{}]*"handle"\\s*:\\s*"${escapeCssIdentifier(handle)}"[^{}]*\\}`));
      if (!match) continue;

      try {
        const product = JSON.parse(match[0]);
        if (product?.handle === handle) return product;
      } catch (_) {
        continue;
      }
    }
  }

  return undefined;
}

function escapeHtml(value = "") {
  return String(value).replace(/[&<>"']/g, (character) => (
    {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[character]
  ));
}

function escapeCssIdentifier(value = "") {
  return typeof window.CSS?.escape === "function" ? window.CSS.escape(String(value)) : String(value).replace(/"/g, '\\"');
}

function pendingCartCountDelta() {
  return [...state.pendingCartCountDeltas.values()].reduce((sum, value) => sum + value, 0);
}

function displayedCartCount() {
  const confirmed = state.confirmedItemCount ?? confirmedItemCountFromDom();
  return Math.max(0, confirmed + pendingCartCountDelta());
}

function renderHeaderCartCount({ animate = false } = {}) {
  const count = displayedCartCount();

  document.querySelectorAll("cart-icon.header-actions__cart-icon").forEach((cartIcon) => {
    const bubble = cartIcon.querySelector(".cart-bubble");
    const countText = cartIcon.querySelector(".cart-bubble__text-count");
    if (!bubble || !countText) return;

    const visibleCount = count > 99 ? "" : String(count);
    countText.textContent = visibleCount;
    countText.classList.toggle("hidden", count === 0);
    bubble.classList.toggle("visually-hidden", count === 0);
    bubble.toggleAttribute("data-maintain-ratio", count <= 99);
    cartIcon.classList.toggle("header-actions__cart-icon--has-cart", count > 0);

    if (animate && count > 0) {
      window.clearTimeout(bubble.naomiCartCountAnimationTimer);
      bubble.classList.remove("cart-bubble--animating");
      window.requestAnimationFrame(() => {
        bubble.classList.add("cart-bubble--animating");
        bubble.naomiCartCountAnimationTimer = window.setTimeout(() => {
          bubble.classList.remove("cart-bubble--animating");
        }, 360);
      });
    }
  });
}

function setOptimisticCartCountDelta(key, delta, { animate = true } = {}) {
  const numericDelta = Number(delta);
  if (!key || !Number.isFinite(numericDelta)) return;

  if (numericDelta === 0) {
    state.pendingCartCountDeltas.delete(key);
    state.pendingCartCountTargets.delete(key);
  } else {
    state.pendingCartCountDeltas.set(key, numericDelta);
    state.pendingCartCountTargets.set(key, displayedCartCount());
  }

  renderHeaderCartCount({ animate });
}

function clearOptimisticCartCountDelta(key, { animate = false } = {}) {
  if (!key) return;
  state.pendingCartCountDeltas.delete(key);
  state.pendingCartCountTargets.delete(key);
  renderHeaderCartCount({ animate });
}

function clearOptimisticCartCountDeltas(prefix, { animate = false } = {}) {
  [...state.pendingCartCountDeltas.keys()].forEach((key) => {
    if (!prefix || key.startsWith(prefix)) {
      state.pendingCartCountDeltas.delete(key);
      state.pendingCartCountTargets.delete(key);
    }
  });
  renderHeaderCartCount({ animate });
}

function shouldClearConfirmedPendingCount(key, confirmedCount) {
  const delta = state.pendingCartCountDeltas.get(key);
  const target = state.pendingCartCountTargets.get(key);
  if (!Number.isFinite(delta) || !Number.isFinite(target)) return true;

  return delta >= 0 ? confirmedCount >= target : confirmedCount <= target;
}

function clearConfirmedPendingCartCount(key, confirmedCount) {
  if (!key || !state.pendingCartCountDeltas.has(key)) return;
  if (!shouldClearConfirmedPendingCount(key, confirmedCount)) return;

  state.pendingCartCountDeltas.delete(key);
  state.pendingCartCountTargets.delete(key);
}

function clearPendingCartCount(key) {
  if (!key) return;
  state.pendingCartCountDeltas.delete(key);
  state.pendingCartCountTargets.delete(key);
}

function clearPendingCartCountPrefix(prefix) {
  [...state.pendingCartCountDeltas.keys()].forEach((key) => {
    if (key.startsWith(prefix)) clearPendingCartCount(key);
  });
}

function syncConfirmedCartCount(
  cart,
  { clearPendingKeys = [], clearPendingPrefixes = [], forceClearPendingKeys = [], forceClearPendingPrefixes = [] } = {},
) {
  if (!cart || cart.item_count === undefined) return;

  const confirmedCount = Number(cart.item_count) || 0;

  forceClearPendingKeys.forEach(clearPendingCartCount);
  forceClearPendingPrefixes.forEach(clearPendingCartCountPrefix);
  clearPendingKeys.forEach((key) => clearConfirmedPendingCartCount(key, confirmedCount));
  clearPendingPrefixes.forEach((prefix) => {
    [...state.pendingCartCountDeltas.keys()].forEach((key) => {
      if (key.startsWith(prefix)) clearConfirmedPendingCartCount(key, confirmedCount);
    });
  });
  state.confirmedItemCount = confirmedCount;
  getRoot()?.setAttribute("data-cart-item-count", String(state.confirmedItemCount));
  renderHeaderCartCount();
}

async function shopifyFetch(path, options = {}) {
  const url = endpoint(path);
  const headers = {
    Accept: "application/json",
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...options.headers,
  };

  if (typeof window.fetch === "function") {
    state.internalRequestDepth += 1;
    let response;

    try {
      response = await window.fetch(url, {
        ...options,
        headers,
      });
    } finally {
      state.internalRequestDepth = Math.max(0, state.internalRequestDepth - 1);
    }

    if (!response.ok) {
      throw new Error(`Naomi cart request failed: ${response.status}`);
    }

    return response.json();
  }

  return new Promise((resolve, reject) => {
    if (typeof window.XMLHttpRequest !== "function") {
      reject(new Error("Naomi cart request failed: no browser request API is available."));
      return;
    }

    const request = new window.XMLHttpRequest();
    request.open(options.method || "GET", url);
    Object.entries(headers).forEach(([key, value]) => request.setRequestHeader(key, value));
    request.onload = () => {
      if (request.status < 200 || request.status >= 300) {
        reject(new Error(`Naomi cart request failed: ${request.status}`));
        return;
      }

      try {
        resolve(JSON.parse(request.responseText));
      } catch (error) {
        reject(error);
      }
    };
    request.onerror = () => reject(new Error("Naomi cart request failed."));
    request.send(options.body);
  });
}

function cartSectionPayload() {
  return {
    sections: getConfig().sectionId,
    sections_url: window.location.pathname,
  };
}

function cartBodyWithSections(body, options = {}) {
  if (options.sections === false) return body;
  return {
    ...body,
    ...cartSectionPayload(),
  };
}

function bodyWithCartSections(body) {
  if (!body) return body;
  const payload = cartSectionPayload();

  if (typeof FormData !== "undefined" && body instanceof FormData) {
    const nextBody = new FormData();
    body.forEach((value, key) => nextBody.append(key, value));
    if (!nextBody.has("sections")) nextBody.append("sections", payload.sections);
    if (!nextBody.has("sections_url")) nextBody.append("sections_url", payload.sections_url);
    return nextBody;
  }

  if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
    const nextBody = new URLSearchParams(body);
    if (!nextBody.has("sections")) nextBody.set("sections", payload.sections);
    if (!nextBody.has("sections_url")) nextBody.set("sections_url", payload.sections_url);
    return nextBody;
  }

  if (typeof body === "string") {
    const text = body.trim();

    if (text.startsWith("{")) {
      try {
        return JSON.stringify(cartBodyWithSections(JSON.parse(body)));
      } catch (error) {
        return body;
      }
    }

    try {
      const nextBody = new URLSearchParams(text);
      if (!nextBody.has("sections")) nextBody.set("sections", payload.sections);
      if (!nextBody.has("sections_url")) nextBody.set("sections_url", payload.sections_url);
      return nextBody.toString();
    } catch (error) {
      return body;
    }
  }

  return body;
}

function requestWithCartSections(input, init = {}) {
  if (!init?.body) return init;

  return {
    ...init,
    body: bodyWithCartSections(init.body),
  };
}

function cartAddDetailsFromParams(params) {
  const details = {
    quantity: Number(params.get("quantity")) || 1,
    sellingPlan: undefined,
    variantId: undefined,
  };
  const directSellingPlan = params.get("selling_plan") || params.get("sellingPlan");

  details.sellingPlan = directSellingPlan || undefined;
  details.variantId = params.get("id") || undefined;

  const indexedItems = new Map();
  const unindexedItems = { id: [], quantity: [], selling_plan: [] };

  params.forEach((value, key) => {
    const indexedMatch = key.match(/^items\[(\d+)]\[(id|quantity|selling_plan|sellingPlan)]$/);
    if (indexedMatch) {
      const index = Number(indexedMatch[1]);
      const field = indexedMatch[2] === "sellingPlan" ? "selling_plan" : indexedMatch[2];
      const item = indexedItems.get(index) || {};
      item[field] = value;
      indexedItems.set(index, item);
      return;
    }

    const unindexedMatch = key.match(/^items\[\]\[(id|quantity|selling_plan|sellingPlan)]$/);
    if (unindexedMatch) {
      const field = unindexedMatch[1] === "sellingPlan" ? "selling_plan" : unindexedMatch[1];
      unindexedItems[field].push(value);
    }
  });

  const items = [
    ...[...indexedItems.entries()]
      .sort(([left], [right]) => left - right)
      .map(([, item]) => item),
  ];
  const unindexedItemCount = Math.max(unindexedItems.id.length, unindexedItems.quantity.length, unindexedItems.selling_plan.length);
  for (let index = 0; index < unindexedItemCount; index += 1) {
    items.push({
      id: unindexedItems.id[index],
      quantity: unindexedItems.quantity[index],
      selling_plan: unindexedItems.selling_plan[index],
    });
  }

  const populatedItems = items.filter((item) => item.id || item.quantity || item.selling_plan);
  if (populatedItems.length === 0) return details;

  const firstItem = populatedItems[0] || {};
  return {
    quantity: populatedItems.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0),
    sellingPlan: firstItem.selling_plan || undefined,
    variantId: firstItem.id || undefined,
  };
}

function cartAddDetailsFromBody(body) {
  const details = {
    quantity: 1,
    sellingPlan: undefined,
    variantId: undefined,
  };

  if (!body) return details;

  if (typeof FormData !== "undefined" && body instanceof FormData) {
    return cartAddDetailsFromParams(body);
  }

  if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
    return cartAddDetailsFromParams(body);
  }

  if (typeof body === "string") {
    const text = body.trim();

    if (text.startsWith("{")) {
      try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed.items)) {
          const firstItem = parsed.items[0] || {};
          return {
            quantity: parsed.items.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0),
            sellingPlan: firstItem.selling_plan || firstItem.sellingPlan || undefined,
            variantId: firstItem.id || undefined,
          };
        }

        return {
          quantity: Number(parsed.quantity) || 1,
          sellingPlan: parsed.selling_plan || parsed.sellingPlan || undefined,
          variantId: parsed.id || undefined,
        };
      } catch (error) {
        return details;
      }
    }

    try {
      return cartAddDetailsFromBody(new URLSearchParams(text));
    } catch (error) {
      return details;
    }
  }

  return details;
}

function quantityFromCartAddBody(body) {
  return cartAddDetailsFromBody(body).quantity;
}

function giftDefinition(type, config = getConfig()) {
  if (type === "scrub") {
    return {
      image: config.scrubGiftImage,
      label: "No Fragrance",
      productId: config.scrubGiftProductId,
      removedKey: SCRUB_GIFT_REMOVED_KEY,
      threshold: config.scrubGiftThreshold,
      title: config.scrubGiftTitle || "Free After-Cooking Hand Scrub",
      variantId: config.scrubGiftVariantId,
    };
  }

  return {
    image: getRoot()?.dataset.freeGiftImage,
    label: "Cooking Stinks",
    productId: config.freeGiftProductId,
    removedKey: FREE_GIFT_REMOVED_KEY,
    threshold: config.freeGiftThreshold,
    title: getRoot()?.dataset.freeGiftTitle || "Free Dad Hat",
    variantId: config.freeGiftVariantId,
  };
}

function giftTypeForLine(line, config = getConfig()) {
  if (!line) return undefined;
  if (line.product_id === config.scrubGiftProductId) return "scrub";
  if (line.product_id === config.freeGiftProductId) return "hat";
  if (line.product_id === PAID_HAT_PRODUCT_ID || line.product_id === PAID_NO_FRAGRANCE_PRODUCT_ID) return undefined;

  const naomiGiftType = String(line.properties?.[FREE_GIFT_TYPE_PROPERTY] || "").toLowerCase();
  if (naomiGiftType === "scrub" || naomiGiftType === "hat") return naomiGiftType;

  const rewardVariantId = String(line.properties?.[LEGACY_UPCART_REWARD_PRODUCT_PROPERTY] || "");
  if (rewardVariantId && rewardVariantId === String(config.scrubGiftVariantId || "")) return "scrub";
  if (rewardVariantId && rewardVariantId === String(config.freeGiftVariantId || "")) return "hat";

  const giftLabel = String(line.properties?.[FREE_GIFT_PROPERTY] || "").toLowerCase();
  if (giftLabel.includes("no fragrance") || giftLabel.includes("scrub")) return "scrub";

  if (Boolean(line.properties?.[FREE_GIFT_PROPERTY]) || line.properties?.[LEGACY_UPCART_FREE_GIFT_PROPERTY] === "true") {
    return "hat";
  }

  return undefined;
}

function isFreeGiftLine(line, config = getConfig()) {
  return Boolean(giftTypeForLine(line, config));
}

function findGiftLineIndex(cart, type, config = getConfig()) {
  return cart?.items?.findIndex((line) => giftTypeForLine(line, config) === type) ?? -1;
}

function cartContainsGift(cart, type, config = getConfig()) {
  return findGiftLineIndex(cart, type, config) >= 0;
}

function qualifyingSubtotal(cart, config = getConfig()) {
  return cart.items
    .filter((line) => !isFreeGiftLine(line, config))
    .reduce((sum, line) => sum + (line.final_line_price ?? line.line_price ?? line.original_line_price), 0);
}

function giftQualifyingAmount(type, cart, config = getConfig()) {
  const merchandiseSubtotal = qualifyingSubtotal(cart, config);
  if (type !== "scrub") return merchandiseSubtotal;

  const cartTotal = Number(cart?.total_price);
  return Number.isFinite(cartTotal) ? cartTotal : merchandiseSubtotal;
}

function removedGiftSubtotal(type = "hat") {
  const value = Number(window.sessionStorage.getItem(giftDefinition(type).removedKey));
  return Number.isFinite(value) ? value : undefined;
}

function hasRemovedGift(type, qualifyingAmount, config = getConfig()) {
  const removedSubtotal = removedGiftSubtotal(type);
  return removedSubtotal !== undefined && qualifyingAmount >= giftDefinition(type, config).threshold;
}

function setRemovedGift(type, isRemoved, cart) {
  const { removedKey, threshold } = giftDefinition(type);

  if (isRemoved) {
    const config = getConfig();
    const qualifyingAmount = cart?.items ? giftQualifyingAmount(type, cart, config) : Number(cart);
    state.giftQualifyingSubtotal = qualifyingAmount;
    if (Number.isFinite(qualifyingAmount) && qualifyingAmount >= threshold) {
      window.sessionStorage.setItem(removedKey, "1");
    } else {
      window.sessionStorage.removeItem(removedKey);
    }
  } else {
    window.sessionStorage.removeItem(removedKey);
  }
}

function hasRemovedFreeGift(qualifyingAmount, config = getConfig()) {
  return hasRemovedGift("hat", qualifyingAmount, config);
}

function setRemovedFreeGift(isRemoved, cart) {
  setRemovedGift("hat", isRemoved, cart);
}

function normalizeId(id) {
  if (typeof id === "number") {
    return Number.isSafeInteger(id) ? id : String(Math.trunc(id));
  }

  return String(id || "").trim();
}

async function addVariant(variantId, quantity = 1, properties, sellingPlan, options = {}) {
  const item = {
    id: normalizeId(variantId),
    quantity: Number(quantity) || 1,
  };

  if (properties && Object.keys(properties).length > 0) {
    item.properties = properties;
  }

  if (sellingPlan) {
    item.selling_plan = normalizeId(sellingPlan);
  }

  return shopifyFetch("cart/add.js", {
    body: JSON.stringify(cartBodyWithSections({
      items: [item],
    }, options)),
    method: "POST",
  });
}

function isCartAddForm(form) {
  const action = form.getAttribute("action") || "";
  return action.includes("/cart/add");
}

function isCartAddUrl(url) {
  try {
    const parsed = new URL(typeof url === "string" ? url : url?.url, window.location.origin);
    return parsed.pathname.endsWith("/cart/add") || parsed.pathname.endsWith("/cart/add.js");
  } catch (error) {
    return String(url).includes("/cart/add");
  }
}

function cartAddSubmitControlFromTarget(target) {
  const control = target.closest("button, input, [role='button']");
  if (!control) return undefined;

  const form = control.closest("form[action*='/cart/add']");
  if (!form) return undefined;

  return isLikelyReploAddControl(control) ? form : undefined;
}

function markExternalAddNoOpen() {
  state.externalAddNoOpenUntil = Date.now() + 1600;
}

function shouldOpenForExternalAdd() {
  return Date.now() >= state.externalAddNoOpenUntil && shouldAllowAutomaticOpen();
}

function shouldAllowAutomaticOpen() {
  return Date.now() >= state.manualCartClosedUntil;
}

function markManualCartClose() {
  state.manualCartClosedUntil = Date.now() + MANUAL_CLOSE_REOPEN_SUPPRESS_MS;
}

function clearManualCartClose() {
  state.manualCartClosedUntil = 0;
}

function cartAddPayloadFromForm(form) {
  const properties = {};

  form.querySelectorAll("[name^='properties[']").forEach((input) => {
    const match = input.name.match(/^properties\[(.+)]$/);
    if (match && input.value) properties[match[1]] = input.value;
  });

  return {
    properties,
    quantity: formValue(form, "quantity") || 1,
    sellingPlan: formValue(form, "selling_plan") || undefined,
    variantId: formValue(form, "id"),
  };
}

function formValue(form, name) {
  if (!form) return undefined;

  const fields = [...form.querySelectorAll(`[name='${name}']`)];
  const checked = fields.find((field) => field.matches("input[type='radio']:checked, input[type='checkbox']:checked"));
  if (checked?.value) return checked.value;

  const selected = fields.find((field) => field.matches("select") && field.value);
  if (selected?.value) return selected.value;

  const valued = fields.find((field) => {
    if (field.disabled || !field.value) return false;
    if (field.matches("input[type='radio'], input[type='checkbox']")) return false;
    return true;
  });

  return valued?.value;
}

function productHandleFromForm(form, { allowCurrent = true } = {}) {
  if (!form) return undefined;

  const reploProduct = form.closest("[data-replo-product-handle]");
  if (reploProduct?.dataset.reploProductHandle) return reploProduct.dataset.reploProductHandle;

  const directHandle = form.dataset.productHandle || form.dataset.reploProductHandle;
  if (directHandle) return directHandle;

  return allowCurrent ? currentProductHandle() : undefined;
}

function productHandleFromTarget(target) {
  if (!target) return undefined;

  const reploProduct = target.closest("[data-replo-product-handle]");
  if (reploProduct?.dataset.reploProductHandle) return reploProduct.dataset.reploProductHandle;

  const directHandle = target.dataset?.productHandle || target.dataset?.reploProductHandle;
  if (directHandle) return directHandle;

  return productHandleFromLink(target);
}

function optimisticProductFromAddButton(button) {
  const handleProduct = optimisticProductFromHandle(button.dataset.productHandle);
  const isSubscription = button.dataset.productSubscription === "true";
  const isSubscribable = !isSubscription && (
    button.dataset.productSubscribable === "true" ||
    handleProduct.isSubscribable
  );
  const dataPrice = Number(button.dataset.productPrice);
  const visiblePrice = centsFromMoneyText(button.textContent);
  const price = isSubscription
    ? firstValidCents(visiblePrice, dataPrice)
    : firstValidCents(dataPrice, visiblePrice);
  const priceIncludesSubscriptionDiscount = isSubscription ? visiblePrice !== undefined && price === visiblePrice : undefined;

  return {
    handle: button.dataset.productHandle,
    image: button.dataset.productImage,
    isSubscribable,
    isSubscription,
    price,
    priceIncludesSubscriptionDiscount,
    sku: button.dataset.productSku,
    subtitle: cleanOptimisticProductSubtitle(button.dataset.productSubtitle),
    title: cleanOptimisticProductTitle(button.dataset.productTitle),
    variantId: button.dataset.variantId,
  };
}

function closestProductCard(control) {
  return control?.closest(
    [
      "[data-replo-product-container]",
      "[data-replo-product-handle]",
      "[data-product-card]",
      ".product-card",
      "product-card",
      "[class*='product-card']",
      "[class*='ProductCard']",
    ].join(", "),
  );
}

function productHandleFromCard(card) {
  if (!card) return undefined;

  const directHandle = card.dataset?.reploProductHandle || card.dataset?.productHandle;
  if (directHandle) return directHandle;
  if (!isScopedProductContext(card)) return undefined;

  return (
    productHandleFromLink(card) ||
    productHandleFromCardText(card)
  );
}

function purchaseOptionLabel(control) {
  return compactText(`${control?.getAttribute?.("aria-label") || ""} ${control?.textContent || ""}`).toLowerCase();
}

function isPurchaseOptionOnlyControl(control) {
  const label = purchaseOptionLabel(control);
  if (!label) return false;
  if (/\b(add|cart|pre-order)\b/i.test(label)) return false;

  return /\bone\s*time\b/i.test(label) || /subscribe\s*&\s*save/i.test(label);
}

function productPagePurchaseRoot(control, form) {
  const handle = currentProductHandle();
  const start = control || form;
  if (!handle || !start) return undefined;

  const cardHandle = productHandleFromCard(closestProductCard(start));
  if (cardHandle && cardHandle !== handle) return undefined;

  let node = start;
  while (node && node instanceof Element && node !== document.body) {
    if (node.matches("main, [role='main']")) break;

    const text = compactText(node.innerText || node.textContent || "").toLowerCase();
    if (
      text.includes("one time") &&
      text.includes("subscribe") &&
      (text.includes("add to cart") || text.includes("pre-order"))
    ) {
      return node;
    }

    if (node.matches("product-form-component")) break;
    node = node.parentElement;
  }

  return undefined;
}

function isFocusedPdpAddControl(control, form) {
  const handle = currentProductHandle();
  if (!handle || !control) return false;

  const label = labeledControlText(control).toLowerCase();
  if (!/\badd to cart\b|pre-order/i.test(label)) return false;

  const cardHandle = productHandleFromCard(closestProductCard(control || form));
  if (cardHandle && cardHandle !== handle) return false;

  return Boolean(productPagePurchaseRoot(control, form)) || /\badd to cart\b/i.test(label);
}

function labeledControlText(control) {
  if (!control) return "";
  if (control.matches?.("input")) {
    const label =
      control.closest("label") ||
      (control.id ? document.querySelector(`label[for='${escapeCssIdentifier(control.id)}']`) : undefined);
    return compactText(`${control.getAttribute("aria-label") || ""} ${label?.textContent || ""} ${control.value || ""}`);
  }

  return compactText(`${control.getAttribute?.("aria-label") || ""} ${control.textContent || ""}`);
}

function isVisibleElement(element) {
  if (!(element instanceof Element)) return false;
  const style = window.getComputedStyle(element);
  return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
}

function optionCandidateElements(root, pattern) {
  if (!root) return [];

  return [...root.querySelectorAll("button, label, [role='button'], [tabindex], input, div, span")]
    .filter((element) => {
      if (!isVisibleElement(element)) return false;
      const text = labeledControlText(element);
      if (!pattern.test(text)) return false;
      if (/add to cart|pre-order/i.test(text)) return false;
      return text.length <= 90;
    })
    .sort((a, b) => {
      const aRect = a.getBoundingClientRect();
      const bRect = b.getBoundingClientRect();
      return (aRect.width * aRect.height) - (bRect.width * bRect.height);
    });
}

function colorNumbers(value = "") {
  const match = value.match(/rgba?\(([^)]+)\)/i);
  if (!match) return [];

  return match[1].split(",").map((part) => Number(part.trim()));
}

function isDarkColor(value) {
  const [red, green, blue, alpha = 1] = colorNumbers(value);
  if (![red, green, blue].every(Number.isFinite) || alpha === 0) return false;
  return (red + green + blue) / 3 < 95;
}

function isLightColor(value) {
  const [red, green, blue, alpha = 1] = colorNumbers(value);
  if (![red, green, blue].every(Number.isFinite) || alpha === 0) return false;
  return (red + green + blue) / 3 > 235;
}

function activeStateScore(element) {
  if (!element) return 0;

  let score = 0;
  if (element.matches?.("input[type='radio']:checked, input[type='checkbox']:checked")) score += 8;
  if (element.querySelector?.("input[type='radio']:checked, input[type='checkbox']:checked")) score += 8;
  if (element.matches?.("[aria-pressed='true'], [aria-selected='true'], [data-selected='true'], [data-active='true'], .is-selected, .selected, [class*='--selected'], [class*='isSelected']")) score += 6;

  const style = window.getComputedStyle(element);
  const borderWidth =
    parseFloat(style.borderTopWidth || "0") +
    parseFloat(style.borderRightWidth || "0") +
    parseFloat(style.borderBottomWidth || "0") +
    parseFloat(style.borderLeftWidth || "0");
  const outlineWidth = parseFloat(style.outlineWidth || "0");
  const boxShadow = style.boxShadow || "";

  if (borderWidth >= 5 && isDarkColor(style.borderTopColor)) score += 5;
  if (outlineWidth >= 2 && isDarkColor(style.outlineColor)) score += 5;
  if (/rgb\(0,\s*0,\s*0\)|rgba\(0,\s*0,\s*0/i.test(boxShadow)) score += 4;
  if (isLightColor(style.backgroundColor)) score += 1;

  return score;
}

function selectedPurchaseOptionFromRoot(root) {
  if (!root) return undefined;

  const oneTimeScore = optionCandidateElements(root, /\bone\s*time\b/i)
    .reduce((score, element) => Math.max(score, activeStateScore(element)), 0);
  const subscriptionScore = optionCandidateElements(root, /subscribe\s*&\s*save|subscription/i)
    .reduce((score, element) => Math.max(score, activeStateScore(element)), 0);

  if (subscriptionScore > oneTimeScore) return "subscription";
  if (oneTimeScore > subscriptionScore) return "one-time";
  return undefined;
}

function subscriptionIntentFromContext(control, form, payload = {}) {
  if (payload.sellingPlan) return true;

  const controlLabel = labeledControlText(control).toLowerCase();
  if (/subscribe(?!\s*&\s*save)/i.test(controlLabel) && !/\bone\s*time\b/i.test(controlLabel)) return true;

  const purchaseRoot = productPagePurchaseRoot(control, form);
  const root =
    purchaseRoot ||
    control?.closest?.("product-form-component, [data-replo-product-container], [data-replo-product-handle]") ||
    form?.closest?.("product-form-component, [data-replo-product-container], [data-replo-product-handle]") ||
    form;

  if (!root) return false;

  const selectedPurchaseOption = selectedPurchaseOptionFromRoot(root);
  if (selectedPurchaseOption === "subscription") return true;
  if (selectedPurchaseOption === "one-time") return false;

  const activeControls = [
    ...root.querySelectorAll(
      [
        "input[type='radio']:checked",
        "input[type='checkbox']:checked",
        "[aria-pressed='true']",
        "[aria-selected='true']",
        "[data-selected='true']",
        "[data-active='true']",
        ".is-selected",
        ".selected",
        "[class*='--selected']",
        "[class*='isSelected']",
      ].join(", "),
    ),
  ];

  const activeText = activeControls.map(labeledControlText).join(" ").toLowerCase();
  if (/\bone\s*time\b/i.test(activeText)) return false;
  if (/subscribe|subscription|deliver every|every\s+\d+\s+months?/i.test(activeText)) return true;

  return false;
}

function visibleQuantityFromContext(control, form) {
  const formQuantity = Number(formValue(form, "quantity"));
  if (Number.isFinite(formQuantity) && formQuantity > 0) return formQuantity;

  const root = productPagePurchaseRoot(control, form);
  if (!root) return undefined;

  const input = root.querySelector("input[name='quantity'], input[id*='quantity' i], input[class*='quantity' i]");
  const inputQuantity = Number(input?.value);
  if (Number.isFinite(inputQuantity) && inputQuantity > 0) return inputQuantity;

  const controls = [...root.querySelectorAll("button, [role='button']")];
  const quantityButtons = controls.filter((candidate) => {
    const label = labeledControlText(candidate);
    return /^[-−+]$/.test(label) || /increase quantity|decrease quantity/i.test(label);
  });
  const stepper = quantityButtons
    .map((candidate) => candidate.parentElement)
    .find((parent) => parent && quantityButtons.filter((candidate) => candidate.parentElement === parent).length >= 2);
  const stepperText = compactText(stepper?.textContent || "");
  const quantityMatch = stepperText.match(/\b([1-9]\d?)\b/);

  return quantityMatch ? Number(quantityMatch[1]) : undefined;
}

function optimisticProductFromExternalAddTarget(target, reploAddTarget, { forceCurrentProduct = false } = {}) {
  const control = reploAddTarget?.control || target.closest("button, input, [role='button'], [tabindex='0']");
  const form = reploAddTarget?.form || (target instanceof HTMLFormElement ? target : control?.closest("form[action*='/cart/add']"));
  const rawCard = closestProductCard(control || form);
  const payload = form ? cartAddPayloadFromForm(form) : {};
  const cardHandle = forceCurrentProduct ? undefined : productHandleFromCard(rawCard);
  const card = !forceCurrentProduct && rawCard && (cardHandle || isScopedProductContext(rawCard)) ? rawCard : undefined;
  const explicitHandle = forceCurrentProduct
    ? currentProductHandle()
    : (
        reploAddTarget?.handle ||
        cardHandle ||
        productHandleFromTarget(control || form) ||
        productHandleFromForm(form, { allowCurrent: false })
      );
  const purchaseRoot = forceCurrentProduct
    ? productPagePurchaseRoot(control || form, form)
    : explicitHandle && explicitHandle !== currentProductHandle()
    ? undefined
    : productPagePurchaseRoot(control || form, form);
  const quantity = visibleQuantityFromContext(control || form, form) || Number(payload.quantity) || 1;
  const pdpHandle = !explicitHandle && (
    purchaseRoot ||
    (control || form)?.closest?.("product-form-component")
  ) ? currentProductHandle() : undefined;
  const handle = explicitHandle || pdpHandle;
  const handleProduct = optimisticProductFromHandle(handle);
  const productData = embeddedProductDataForHandle(handle);
  const productDataTitle = optimisticTitleFromProductData(productData);
  const contextRoot = card || purchaseRoot;
  const image = imageFromClosestContext(control || form, contextRoot);
  const isSubscription = subscriptionIntentFromContext(control || form, form, payload);
  const isSubscribable = !isSubscription && (handleProduct.isSubscribable || productDataHasSellingPlans(productData));
  const pricePayload = isSubscription ? { ...payload, sellingPlan: payload.sellingPlan || "optimistic-subscription" } : payload;
  const titleElement = contextRoot?.querySelector("[data-product-title], [data-replo-product-title], h1, h2, h3");
  const priceElement = contextRoot?.querySelector("[data-product-price], [data-price], .price, [class*='price']") || control;
  const firstVariant = productData?.variants?.find?.((variant) => variant?.available || variant?.availableForSale) || productData?.variants?.[0];
  const dataPrice = Number(control?.dataset.productPrice || card?.dataset.productPrice);
  const controlTextPrice = centsFromMoneyText(control?.textContent);
  const purchaseOptionPrice = centsFromPurchaseOptionContext(control || form, pricePayload, purchaseRoot || card);
  const fallbackTextPrice = centsFromMoneyText(priceElement?.textContent);
  const productDataPrice = Number(firstVariant?.price || productData?.price);
  const selectedSubscriptionPrice = firstValidCents(purchaseOptionPrice, controlTextPrice);
  const price = isSubscription
    ? firstValidCents(selectedSubscriptionPrice, dataPrice, fallbackTextPrice, productDataPrice)
    : firstValidCents(dataPrice, controlTextPrice, purchaseOptionPrice, fallbackTextPrice, productDataPrice);
  const priceIncludesSubscriptionDiscount = isSubscription ? selectedSubscriptionPrice !== undefined : undefined;
  const fragments = visibleTextFragments(card, control);
  const title =
    cleanOptimisticProductTitle(control?.dataset.productTitle) ||
    cleanOptimisticProductTitle(card?.dataset.productTitle) ||
    handleProduct.title ||
    productDataTitle.title ||
    cleanOptimisticProductTitle(titleElement?.textContent) ||
    cleanOptimisticProductTitle(fragments[0]) ||
    cleanOptimisticProductTitle(image?.getAttribute?.("alt"));
  const subtitle =
    cleanOptimisticProductSubtitle(control?.dataset.productSubtitle) ||
    cleanOptimisticProductSubtitle(card?.dataset.productSubtitle) ||
    handleProduct.subtitle ||
    productDataTitle.subtitle ||
    fragments.find((fragment) => fragment !== title);

  if (!image?.currentSrc && !image?.src && !handleProduct.image && !title && !Number.isFinite(price)) return {};

  return {
    handle,
    image: optimisticImageUrl({ card, handle, handleProduct, image, productData, preferHandleImage: Boolean(purchaseRoot && !cardHandle) }),
    isSubscription,
    isSubscribable,
    price,
    priceIncludesSubscriptionDiscount,
    quantity,
    sellingPlan: payload.sellingPlan,
    sku: control?.dataset.productSku || card?.dataset.productSku || firstVariant?.sku,
    subtitle,
    title,
    variantId:
      payload.variantId ||
      control?.dataset.variantId ||
      control?.dataset.reploAddProductVariantToCart ||
      reploAddTarget?.variantId,
  };
}

function nextPendingCartCountKey(prefix = "cart") {
  state.pendingCartCountSeq += 1;
  return `${prefix}:${state.pendingCartCountSeq}`;
}

function pendingLineCartCountKey(line, fallbackLineIndex) {
  return `line:${line?.dataset.lineKey || fallbackLineIndex || "unknown"}`;
}

function subscriptionIdentitySuffix(isSubscription) {
  return isSubscription ? ":subscription" : ":one-time";
}

function lineQuantityIdentityKeys({ line, lineKey, productHandle, variantId, isSubscription } = {}) {
  const lineIsSubscription = isSubscription ?? line?.dataset?.isSubscription === "true";
  const suffix = subscriptionIdentitySuffix(lineIsSubscription);

  return [
    lineKey && `line:${lineKey}`,
    line?.dataset?.lineKey && `line:${line.dataset.lineKey}`,
    variantId && `variant:${normalizeId(variantId)}${suffix}`,
    line?.dataset?.variantId && `variant:${normalizeId(line.dataset.variantId)}${suffix}`,
    productHandle && `handle:${productHandle}${suffix}`,
    line?.dataset?.productHandle && `handle:${line.dataset.productHandle}${suffix}`,
  ].filter(Boolean);
}

function cartItemQuantityIdentityKeys(item = {}) {
  const suffix = subscriptionIdentitySuffix(Boolean(item.selling_plan_allocation));

  return [
    item.key && `line:${item.key}`,
    item.variant_id && `variant:${normalizeId(item.variant_id)}${suffix}`,
    item.product_handle && `handle:${item.product_handle}${suffix}`,
  ].filter(Boolean);
}

function rememberPendingLineQuantityIntent(timerKey, { line, lineIndex, lineKey, mutationSeq, quantity } = {}) {
  if (!timerKey) return;

  state.pendingLineQuantityIntents.set(timerKey, {
    createdAt: Date.now(),
    identityKeys: lineQuantityIdentityKeys({ line, lineKey }),
    mutationSeq,
    quantity: Number(quantity),
  });
}

function cartConfirmsLineQuantityIntent(cart, intent) {
  if (!cart?.items || !intent?.identityKeys?.length) return true;

  const targetQuantity = Number(intent.quantity);
  if (!Number.isFinite(targetQuantity)) return true;

  const matchingItems = cart.items.filter((item) => {
    const itemKeys = cartItemQuantityIdentityKeys(item);
    return intent.identityKeys.some((key) => itemKeys.includes(key));
  });

  if (targetQuantity <= 0) return matchingItems.length === 0;
  return matchingItems.some((item) => Number(item.quantity) === targetQuantity);
}

function pruneConfirmedLineQuantityIntents(cart) {
  state.pendingLineQuantityIntents.forEach((intent, timerKey) => {
    const isExpired = Date.now() - Number(intent.createdAt || 0) > LINE_QUANTITY_INTENT_MAX_AGE_MS;
    if (isExpired || cartConfirmsLineQuantityIntent(cart, intent)) {
      state.pendingLineQuantityIntents.delete(timerKey);
    }
  });
}

function hasUnconfirmedLineQuantityIntents(cart) {
  pruneConfirmedLineQuantityIntents(cart);
  return state.pendingLineQuantityIntents.size > 0;
}

function stableLineChangeKey(line, fallbackLineIndex, fallbackLineKey) {
  if (line instanceof HTMLElement) {
    if (!line.dataset.naomiLineQueueKey) {
      line.dataset.naomiLineQueueKey = `line:${fallbackLineKey || fallbackLineIndex || "unknown"}`;
    }

    return line.dataset.naomiLineQueueKey;
  }

  return `line:${fallbackLineKey || fallbackLineIndex || "unknown"}`;
}

async function variantIdFromProductHandle(handle) {
  if (!handle) return undefined;

  const product = await shopifyFetch(`products/${handle}.js`);
  const variant = product.variants?.find((candidate) => candidate.available) || product.variants?.[0];
  return variant?.id;
}

async function handleCartAddForm(form) {
  const payload = cartAddPayloadFromForm(form);
  let variantId = payload.variantId;
  const handle = productHandleFromForm(form);
  const pendingCountKey = nextPendingCartCountKey("form-add");

  appendPendingLine({
    ...optimisticProductFromExternalAddTarget(form),
    pendingCountKey,
  });
  openCart();
  setOptimisticCartCountDelta(pendingCountKey, Number(payload.quantity) || 1);

  try {
    if (!variantId) {
      variantId = await variantIdFromProductHandle(handle);
    }

    if (!variantId) {
      clearOptimisticCartCountDelta(pendingCountKey);
      await refresh();
      return;
    }

    const response = await addVariant(variantId, payload.quantity, payload.properties, payload.sellingPlan);
    await reconcileCartMutation(response, { forceClearPendingKeys: [pendingCountKey], open: true });
  } catch (error) {
    clearOptimisticCartCountDelta(pendingCountKey);
    throw error;
  }
}

function isLikelyReploAddControl(control, { explicitAdd = false } = {}) {
  if (control.matches("a, [role='link']")) return false;
  if (isPurchaseOptionOnlyControl(control)) return false;
  if (explicitAdd) return true;

  const form = control.closest("form[action*='/cart/add']");
  if (form && control.matches("button[type='submit'], input[type='submit']")) return true;

  const label = `${control.getAttribute("aria-label") || ""} ${control.textContent || ""}`.trim().toLowerCase();
  if (!label) return control.matches("button[type='submit'], input[type='submit']");

  return (
    label.includes("add") ||
    label.includes("cart") ||
    label.includes("pre-order")
  );
}

function shouldKeepDrawerClosedForExternalAdd(target, reploAddTarget) {
  const control = reploAddTarget?.control || target.closest("button, input, [role='button'], [tabindex='0']");
  if (!control) return false;

  return false;
}

function reploCartAddTargetFromEventTarget(target) {
  const reploAddButton = target.closest("[data-replo-add-product-variant-to-cart]");
  const control = reploAddButton || target.closest("button, [role='button'], [tabindex='0']");
  if (
    !control ||
    control.closest("[data-naomi-cart-dialog]") ||
    isPurchaseOptionOnlyControl(control) ||
    !isLikelyReploAddControl(control, { explicitAdd: Boolean(reploAddButton) })
  ) {
    return undefined;
  }

  const productContainer = control.closest("[data-replo-product-container]");
  const form = productContainer?.querySelector("form[action*='/cart/add']");
  if (!form && !productContainer?.dataset.reploProductHandle) return undefined;

  return {
    control,
    form,
    handle: productContainer?.dataset.reploProductHandle || productHandleFromTarget(control),
  };
}

async function changeLine(line, quantity, sellingPlan, options = {}) {
  const body = {
    quantity: Number(quantity),
  };

  if (options.lineKey) {
    body.id = options.lineKey;
  } else {
    body.line = Number(line);
  }

  if (sellingPlan !== undefined) {
    body.selling_plan = sellingPlan || null;
  }

  return shopifyFetch("cart/change.js", {
    body: JSON.stringify(cartBodyWithSections(body, options)),
    method: "POST",
  });
}

async function syncFreeGift(cart) {
  if (!cart?.items) cart = await shopifyFetch("cart.js");

  const config = getConfig();
  const qualifyingAmount = qualifyingSubtotal(cart, config);
  const scrubQualifyingAmount = giftQualifyingAmount("scrub", cart, config);
  if (state.wasBelowGiftThreshold === undefined) {
    state.wasBelowGiftThreshold = qualifyingAmount < config.freeGiftThreshold;
  }
  if (state.wasBelowScrubGiftThreshold === undefined) {
    state.wasBelowScrubGiftThreshold = scrubQualifyingAmount < config.scrubGiftThreshold;
  }

  const giftTiers = [
    {
      amount: qualifyingAmount,
      crossed: qualifyingAmount >= config.freeGiftThreshold && state.wasBelowGiftThreshold,
      optimisticShown: state.optimisticGiftUnlockShown,
      qualifies: qualifyingAmount >= config.freeGiftThreshold,
      setBelow: (isBelow) => {
        state.wasBelowGiftThreshold = isBelow;
      },
      setOptimisticShown: (shown) => {
        state.optimisticGiftUnlockShown = shown;
      },
      type: "hat",
    },
    {
      amount: scrubQualifyingAmount,
      crossed: scrubQualifyingAmount >= config.scrubGiftThreshold && state.wasBelowScrubGiftThreshold,
      optimisticShown: state.optimisticScrubGiftUnlockShown,
      qualifies: scrubQualifyingAmount >= config.scrubGiftThreshold,
      setBelow: (isBelow) => {
        state.wasBelowScrubGiftThreshold = isBelow;
      },
      setOptimisticShown: (shown) => {
        state.optimisticScrubGiftUnlockShown = shown;
      },
      type: "scrub",
    },
  ];

  for (const tier of giftTiers) {
    if (tier.crossed) {
      setRemovedGift(tier.type, false);
      state.pendingGiftUnlockMoment = !tier.optimisticShown;
      state.pendingGiftUnlockType = tier.type;
    }
  }

  let updatedCart = cart;

  for (const tier of [...giftTiers].reverse()) {
    const giftIndex = findGiftLineIndex(updatedCart, tier.type, config);
    if (!tier.qualifies) {
      tier.setBelow(true);
      tier.setOptimisticShown(false);
      setRemovedGift(tier.type, false);
      if (giftIndex >= 0) {
        updatedCart = await changeLine(giftIndex + 1, 0);
      }
    }
  }

  for (const tier of giftTiers) {
    if (tier.qualifies) tier.setBelow(false);
  }

  for (const tier of giftTiers) {
    const giftIndex = findGiftLineIndex(updatedCart, tier.type, config);
    const giftLine = giftIndex >= 0 ? updatedCart.items[giftIndex] : undefined;
    if (giftLine?.quantity > 1) {
      updatedCart = await changeLine(giftIndex + 1, 1);
    }
  }

  for (const tier of giftTiers) {
    if (!tier.qualifies) continue;

    const gift = giftDefinition(tier.type, config);
    if (cartContainsGift(updatedCart, tier.type, config) || (!tier.crossed && hasRemovedGift(tier.type, tier.amount, config))) {
      continue;
    }

    if (!gift.variantId) {
      console.warn(`Naomi cart: select the ${gift.label} gift product in the cart drawer settings so Shopify can provide its default variant ID.`);
      continue;
    }

    const giftProperties = {
      [FREE_GIFT_PROPERTY]: gift.label,
      [FREE_GIFT_TYPE_PROPERTY]: tier.type,
    };

    try {
      await addVariant(gift.variantId, 1, giftProperties);
      updatedCart = await shopifyFetch("cart.js");
      if (cartContainsGift(updatedCart, tier.type, config)) continue;

      console.warn("Naomi cart: Shopify accepted the free gift add request, but the gift was not present after refresh.", {
        giftType: tier.type,
        qualifyingAmount: tier.amount,
        threshold: gift.threshold,
        variantId: gift.variantId,
      });
    } catch (error) {
      console.warn("Naomi cart: free gift could not be added.", {
        error,
        giftType: tier.type,
        qualifyingAmount: tier.amount,
        threshold: gift.threshold,
        variantId: gift.variantId,
      });
    }
  }

  return updatedCart;
}

function activeRecommendationIndex(container) {
  if (!container) return 0;

  const dataIndex = Number(container.dataset.activeIndex);
  if (Number.isFinite(dataIndex)) return dataIndex;

  const cards = [...container.querySelectorAll("[data-naomi-recommendation-card]")];
  const activeIndex = cards.findIndex((card) => card.classList.contains("is-active"));
  return activeIndex >= 0 ? activeIndex : 0;
}

function applyRecommendationIndex(container, index = 0) {
  const cards = [...container.querySelectorAll("[data-naomi-recommendation-card]")];
  const dots = [...container.querySelectorAll("[data-naomi-recommendation-dot]")];
  if (cards.length === 0) return;

  const safeIndex = ((index % cards.length) + cards.length) % cards.length;
  container.dataset.activeIndex = String(safeIndex);
  container.dataset.direction = "next";
  cards.forEach((card, cardIndex) => {
    card.classList.toggle("is-active", cardIndex === safeIndex);
    card.classList.remove("is-exiting");
  });
  dots.forEach((dot, dotIndex) => {
    dot.classList.toggle("is-active", dotIndex === safeIndex);
    dot.setAttribute("aria-pressed", dotIndex === safeIndex ? "true" : "false");
  });
}

function scrubGiftProgressAmount(root, fallbackAmount) {
  const cartTotal = centsFromDataset(root, "cartTotal");
  return Number.isFinite(cartTotal) ? cartTotal : fallbackAmount;
}

function rewardMaxThreshold(qualifyingSubtotal, config = getConfig(), scrubGiftAmount = qualifyingSubtotal) {
  return Math.max(
    ...rewardTierDefinitions(getRoot(), qualifyingSubtotal, config, scrubGiftAmount)
      .map(({ threshold }) => threshold)
  );
}

function rewardTierDefinitions(root, qualifyingSubtotal, config = getConfig(), scrubGiftAmount = qualifyingSubtotal) {
  return [
    {
      amount: qualifyingSubtotal,
      label: "free shipping",
      recommendationLabel: "Add to unlock free shipping",
      threshold: freeShippingThreshold(root),
      type: "shipping",
    },
    {
      amount: qualifyingSubtotal,
      label: "a free gift",
      recommendationLabel: "Add to unlock free gift",
      threshold: config.freeGiftThreshold,
      type: "hat",
    },
    {
      amount: scrubGiftAmount,
      label: "a free No Fragrance scrub",
      recommendationLabel: "Add to unlock free No Fragrance scrub",
      threshold: config.scrubGiftThreshold,
      type: "scrub",
    },
  ].sort((left, right) => (left.threshold - right.threshold) || (REWARD_TIER_ORDER[left.type] - REWARD_TIER_ORDER[right.type]));
}

function rewardProgressPercent(qualifyingSubtotal, config = getConfig(), scrubGiftAmount = qualifyingSubtotal, root = getRoot()) {
  const tiers = rewardTierDefinitions(root, qualifyingSubtotal, config, scrubGiftAmount);
  if (tiers.every(({ amount, threshold }) => amount >= threshold)) return 100;

  const segment = tiers.find(({ amount, threshold }) => amount < threshold) || tiers[tiers.length - 1];
  const segmentIndex = tiers.indexOf(segment);
  const start = segmentIndex > 0 ? tiers[segmentIndex - 1].threshold : 0;
  const end = Math.max(segment.threshold, start + 1);
  const from = (segmentIndex / tiers.length) * 100;
  const to = ((segmentIndex + 1) / tiers.length) * 100;
  const range = end - start;
  const progress = Math.min(Math.max(segment.amount - start, 0), range) / range;

  return Math.min(from + ((to - from) * progress), 100);
}

function rewardThresholds(root, qualifyingSubtotal, config = getConfig(), scrubGiftAmount = qualifyingSubtotal) {
  return rewardTierDefinitions(root, qualifyingSubtotal, config, scrubGiftAmount)
    .map(({ threshold, type }) => ({ threshold, type }));
}

function rewardMarkerTitle(type) {
  if (type === "shipping") return "Free shipping";
  if (type === "hat") return "Free hat";
  if (type === "scrub") return "Free scrub";
  return "";
}

function rewardProgressHtml(root, qualifyingSubtotal, scrubGiftAmount = scrubGiftProgressAmount(root, qualifyingSubtotal)) {
  const config = getConfig();
  const tiers = rewardTierDefinitions(root, qualifyingSubtotal, config, scrubGiftAmount);
  const nextTier = tiers.find(({ amount, threshold }) => amount < threshold);
  const markers = tiers.map(({ amount, threshold, type }, index) => {
    const position = ((index + 1) / tiers.length) * 100;
    const className = amount >= threshold ? "is-reached" : type === nextTier?.type ? "is-next" : "";
    const edgeAttribute = index === tiers.length - 1 ? ' data-reward-edge="end"' : "";
    return `<i class="${className}" data-reward-marker="${type}" data-reward-tooltip="${escapeHtml(rewardMarkerTitle(type))}"${edgeAttribute} style="left: ${position}%;" aria-hidden="true"></i>`;
  }).join("");

  return `<span class="naomi-cart__progress-fill" style="width: ${rewardProgressPercent(qualifyingSubtotal, config, scrubGiftAmount, root)}%;"></span>${markers}`;
}

function syncRewardProgress(root, qualifyingSubtotal, scrubGiftAmount = scrubGiftProgressAmount(root, qualifyingSubtotal)) {
  const progress = root?.querySelector(".naomi-cart__progress");
  if (progress) progress.innerHTML = rewardProgressHtml(root, qualifyingSubtotal, scrubGiftAmount);
}

function animateNewlyUnlockedRewards(root, previousQualifyingSubtotal, qualifyingSubtotal, previousScrubGiftAmount = previousQualifyingSubtotal, scrubGiftAmount = qualifyingSubtotal) {
  if (!root || prefersReducedMotion()) return;

  const config = getConfig();
  const unlockedMarkers = rewardThresholds(root, qualifyingSubtotal, config, scrubGiftAmount)
    .filter(({ threshold, type }) => {
      const previousAmount = type === "scrub" ? previousScrubGiftAmount : previousQualifyingSubtotal;
      const currentAmount = type === "scrub" ? scrubGiftAmount : qualifyingSubtotal;
      return previousAmount < threshold && currentAmount >= threshold;
    })
    .map(({ type }) => root.querySelector(`.naomi-cart__progress i[data-reward-marker="${type}"]`))
    .filter((marker) => marker instanceof HTMLElement);

  unlockedMarkers.forEach((marker) => {
    marker.classList.remove("is-unlocking");
    marker.getBoundingClientRect();
    marker.classList.add("is-unlocking");
    window.setTimeout(() => marker.classList.remove("is-unlocking"), 460);
  });
}

function animateRewardMessage(root = getRoot()) {
  const rewardText = root?.querySelector(".naomi-cart__rewards p");
  if (!(rewardText instanceof HTMLElement) || prefersReducedMotion()) return;

  window.clearTimeout(state.rewardMessageTimer);
  rewardText.classList.remove("is-progress-updating");
  rewardText.getBoundingClientRect();
  rewardText.classList.add("is-progress-updating");

  state.rewardMessageTimer = window.setTimeout(() => {
    rewardText.classList.remove("is-progress-updating");
  }, 720);
}

function shouldAnimateProgressMessage(previousQualifyingSubtotal, qualifyingSubtotal, previousScrubGiftAmount = previousQualifyingSubtotal, scrubGiftAmount = qualifyingSubtotal) {
  const config = getConfig();
  const previousMax = rewardMaxThreshold(previousQualifyingSubtotal, config, previousScrubGiftAmount);
  const currentMax = rewardMaxThreshold(qualifyingSubtotal, config, scrubGiftAmount);
  const previousProgressAmount = previousScrubGiftAmount;
  const currentProgressAmount = scrubGiftAmount;

  return previousProgressAmount !== currentProgressAmount &&
    (previousProgressAmount < previousMax || currentProgressAmount < currentMax);
}

function shouldAnimateConfirmedProgressMessage(previousQualifyingSubtotal, qualifyingSubtotal, root = getRoot(), previousScrubGiftAmount = previousQualifyingSubtotal, scrubGiftAmount = qualifyingSubtotal) {
  if (previousQualifyingSubtotal === qualifyingSubtotal && previousScrubGiftAmount === scrubGiftAmount) return false;

  const config = getConfig();
  const shippingThreshold = freeShippingThreshold(root);

  return (
    (previousQualifyingSubtotal < shippingThreshold && qualifyingSubtotal >= shippingThreshold) ||
    (previousQualifyingSubtotal < config.freeGiftThreshold && qualifyingSubtotal >= config.freeGiftThreshold) ||
    (previousScrubGiftAmount < config.scrubGiftThreshold && scrubGiftAmount >= config.scrubGiftThreshold)
  );
}

function startGiftUnlockMoment(root = getRoot(), giftType) {
  if (!root || prefersReducedMotion()) return;

  window.clearTimeout(state.giftUnlockTimer);
  root.classList.remove("is-gift-unlocking");
  root.querySelectorAll(".naomi-cart__line.is-gift-unlocking").forEach((line) => {
    line.classList.remove("is-gift-unlocking");
  });
  root.getBoundingClientRect();
  root.classList.add("is-gift-unlocking");
  const giftLine = giftType ?
    root.querySelector(giftLineSelector(giftType)) :
    root.querySelector(".naomi-cart__line.is-free-gift, .naomi-cart__line[data-pending-free-gift='true']");
  giftLine?.classList.add("is-gift-unlocking");

  state.giftUnlockTimer = window.setTimeout(() => {
    root.classList.remove("is-gift-unlocking");
    root.querySelectorAll(".naomi-cart__line.is-gift-unlocking").forEach((line) => {
      line.classList.remove("is-gift-unlocking");
    });
  }, 920);
}

function updateOptimisticCartSummary(deltaTotalCents = 0, deltaQualifyingCents = deltaTotalCents) {
  const root = getRoot();
  if (!root || (!deltaTotalCents && !deltaQualifyingCents)) return;
  ensureRewardsSection(root);

  const config = getConfig();
  const previousQualifyingSubtotal = centsFromDataset(root, "qualifyingSubtotal");
  const previousCartTotal = centsFromDataset(root, "cartTotal");
  const cartTotal = previousCartTotal + deltaTotalCents;
  const qualifyingSubtotal = previousQualifyingSubtotal + deltaQualifyingCents;

  root.dataset.cartTotal = String(cartTotal);
  root.dataset.qualifyingSubtotal = String(qualifyingSubtotal);
  ensureOptimisticCartBottom(root, cartTotal);
  updateRecommendationRewardHeading(root);
  syncOptimisticGiftLine(previousQualifyingSubtotal, qualifyingSubtotal, previousCartTotal, cartTotal);
  syncOptimisticShippingLine(previousQualifyingSubtotal, qualifyingSubtotal);
  syncRewardProgress(root, qualifyingSubtotal, cartTotal);
  animateNewlyUnlockedRewards(root, previousQualifyingSubtotal, qualifyingSubtotal, previousCartTotal, cartTotal);

  const rewardText = root.querySelector(".naomi-cart__rewards p");
  if (rewardText) {
    rewardText.innerHTML = rewardsMessageHtml(root, qualifyingSubtotal);
    if (shouldAnimateProgressMessage(previousQualifyingSubtotal, qualifyingSubtotal, previousCartTotal, cartTotal)) {
      animateRewardMessage(root);
    }
  }

  updateCheckoutAmount(root, cartTotal);

  [
    { shownKey: "optimisticGiftUnlockShown", threshold: config.freeGiftThreshold, type: "hat" },
    { shownKey: "optimisticScrubGiftUnlockShown", threshold: config.scrubGiftThreshold, type: "scrub" },
  ].forEach(({ shownKey, threshold, type }) => {
    const previousAmount = type === "scrub" ? previousCartTotal : previousQualifyingSubtotal;
    const currentAmount = type === "scrub" ? cartTotal : qualifyingSubtotal;
    if (previousAmount >= threshold || currentAmount < threshold || hasGiftLineInDom(type)) return;

    const gift = giftDefinition(type, config);
    state[shownKey] = true;
    startGiftUnlockMoment(root, type);
    appendPendingLine({
      image: gift.image,
      price: 0,
      subtitle: type === "scrub" ? "No Fragrance" : "Cooking Stinks",
      title: gift.title,
      variantId: gift.variantId,
      isFreeGift: true,
      giftType: type,
    });
  });
}

function renderLinePrice(priceText, finalPrice, originalPrice) {
  if (!priceText) return;

  priceText.innerHTML =
    originalPrice > finalPrice
      ? `<span class="naomi-cart__compare-price">${formatCartMoney(originalPrice)}</span>${formatCartMoney(finalPrice)}`
      : formatCartMoney(finalPrice);
}

function updateOptimisticBuyThreeBanner(line, quantity) {
  const existingBanner = line?.querySelector(".naomi-cart__line-deal-banner-wrap");
  if (line?.dataset.isSubscription === "true") {
    existingBanner?.setAttribute("hidden", "");
    existingBanner?.classList.remove("is-entering");
    return;
  }

  const banner = quantity === 2
    ? ensureOptimisticBuyThreeBanner(line)
    : existingBanner;
  if (!banner) return;

  if (quantity === 2) {
    const wasHidden = banner.hasAttribute("hidden");
    banner.removeAttribute("hidden");
    if (wasHidden && !prefersReducedMotion()) {
      banner.classList.remove("is-entering");
      banner.getBoundingClientRect();
      banner.classList.add("is-entering");
      window.setTimeout(() => banner.classList.remove("is-entering"), 280);
    }
  } else {
    banner.setAttribute("hidden", "");
    banner.classList.remove("is-entering");
  }
}

function ensureOptimisticBuyThreeBanner(line) {
  if (!(line instanceof HTMLElement) || line.classList.contains("is-free-gift")) return undefined;
  if (line.dataset.pendingFreeGift === "true" || line.matches("[data-naomi-shipping-reward-line]")) return undefined;

  const existingBanner = line.querySelector(".naomi-cart__line-deal-banner-wrap");
  if (existingBanner instanceof HTMLElement) return existingBanner;

  const discountPercent = buyThreeDiscountPercentForLine(line);
  if (discountPercent <= 0) return undefined;

  const unitOriginalPrice = centsFromDataset(line, "unitOriginalPrice") || centsFromDataset(line, "unitFinalPrice");
  if (unitOriginalPrice <= 0) return undefined;

  const savings = Math.round(unitOriginalPrice * 3 * (discountPercent / 100));
  const lineIndex = line.querySelector("[data-naomi-cart-quantity]")?.dataset.line || "";
  const lineKey = line.dataset.lineKey || "";
  const banner = document.createElement("div");

  banner.className = "naomi-cart__line-deal-banner-wrap";
  banner.hidden = true;
  banner.innerHTML = `
    <div class="naomi-cart__line-deal-banner">
      <span>Save ${formatCartMoney(savings)} when you buy 1 more</span>
      <button
        type="button"
        data-naomi-cart-quantity
        data-naomi-buy-three-discount="${escapeHtml(discountPercent)}"
        data-line="${escapeHtml(lineIndex)}"
        data-line-key="${escapeHtml(lineKey)}"
        data-quantity="3"
      >
        Add
      </button>
    </div>
  `;

  line.append(banner);
  return banner;
}

function subscriptionMetaHtml() {
  return `
    <span class="naomi-cart__meta-item naomi-cart__meta-item--subscription" data-naomi-optimistic-subscription-meta>
      <span class="naomi-cart__meta-separator" aria-hidden="true">&bull;</span>
      <span>Subscription</span>
    </span>
  `;
}

function optimisticCadenceHtml(button, line, quantity) {
  const planName = compactText(button.dataset.sellingPlanName) || "Every 3 months";
  const productTitle = compactText(line?.querySelector(".naomi-cart__line-title h3")?.textContent) || "Product";

  return `
    <label class="naomi-cart__cadence naomi-cart__cadence--pending">
      <span class="visually-hidden">Subscription cadence</span>
      <select
        data-naomi-cart-selling-plan
        data-line="${escapeHtml(button.dataset.line || "")}"
        data-line-key="${escapeHtml(button.dataset.lineKey || line?.dataset.lineKey || "")}"
        data-quantity="${escapeHtml(quantity)}"
        aria-label="${escapeHtml(productTitle)} subscription cadence"
        aria-disabled="true"
        tabindex="-1"
      >
        <option value="${escapeHtml(button.dataset.sellingPlan || "")}" selected>${escapeHtml(planName)}</option>
      </select>
    </label>
  `;
}

function optimisticallySubscribeLine(button) {
  const line = button.closest(".naomi-cart__line");
  if (!(line instanceof HTMLElement)) return;

  const quantity = Math.max(1, Number(button.dataset.quantity || line.dataset.currentQuantity || line.dataset.confirmedQuantity) || 1);
  const previousFinalPrice = centsFromDataset(line, "lineFinalPrice");
  const unitOriginalPrice = centsFromDataset(line, "unitOriginalPrice") || centsFromDataset(line, "unitFinalPrice");
  const nextOriginalPrice = unitOriginalPrice * quantity;

  line.classList.add("is-updating");
  line.dataset.isSubscription = "true";
  line.dataset.currentQuantity = String(quantity);
  line.dataset.lineOriginalPrice = String(nextOriginalPrice);

  const nextFinalPrice = optimisticLineFinalPriceForQuantity(line, quantity, button);
  line.dataset.lineFinalPrice = String(nextFinalPrice);
  line.dataset.unitFinalPrice = String(Math.round(nextFinalPrice / quantity));

  const metaList = line.querySelector(".naomi-cart__meta-list");
  if (metaList && !metaList.querySelector(".naomi-cart__meta-item--subscription")) {
    metaList.insertAdjacentHTML("beforeend", subscriptionMetaHtml());
  }

  renderLinePrice(line.querySelector(".naomi-cart__line-title strong"), nextFinalPrice, nextOriginalPrice);
  button.insertAdjacentHTML("afterend", optimisticCadenceHtml(button, line, quantity));
  button.remove();
  updateOptimisticBuyThreeBanner(line, quantity);
  updateOptimisticCartSummary(nextFinalPrice - previousFinalPrice, nextFinalPrice - previousFinalPrice);
  scheduleCartLayoutUpdate();
}

function dealBannerLineIdentityKeys(line) {
  if (!(line instanceof HTMLElement)) return [];

  return [
    line.dataset.lineKey && `line:${line.dataset.lineKey}`,
    line.dataset.variantId && `variant:${normalizeId(line.dataset.variantId)}`,
    line.dataset.productHandle && `handle:${line.dataset.productHandle}`,
  ].filter(Boolean);
}

function visibleDealBannerLineKeys(root = getRoot()) {
  if (!root) return new Set();

  return new Set(
    [...root.querySelectorAll(".naomi-cart__line")]
      .filter((line) => line.querySelector(".naomi-cart__line-deal-banner-wrap:not([hidden])"))
      .flatMap(dealBannerLineIdentityKeys),
  );
}

function suppressConfirmedDealBannerAnimations(root, visibleLineKeys) {
  if (!root || !visibleLineKeys?.size) return;

  root.querySelectorAll(".naomi-cart__line").forEach((line) => {
    if (!dealBannerLineIdentityKeys(line).some((key) => visibleLineKeys.has(key))) return;
    line.querySelector(".naomi-cart__line-deal-banner-wrap:not([hidden])")?.classList.add("is-animation-suppressed");
  });
}

function moveGiftLinesToBottom(root = getRoot()) {
  const items = root?.querySelector(".naomi-cart__items");
  if (!items) return;

  items
    .querySelectorAll(giftLineSelector("scrub"))
    .forEach((scrubLine) => items.append(scrubLine));

  items
    .querySelectorAll(giftLineSelector("hat"))
    .forEach((hatLine) => items.append(hatLine));

  const shippingLine = items.querySelector("[data-naomi-shipping-reward-line]");
  if (shippingLine) items.append(shippingLine);
}

function giftLineSelector(type) {
  if (type === "shipping") {
    return ".naomi-cart__line[data-naomi-shipping-reward-line]";
  }

  if (type === "scrub") {
    return ".naomi-cart__line.is-free-gift[data-gift-type='scrub'], .naomi-cart__line[data-pending-free-gift='true'][data-gift-type='scrub']";
  }

  return ".naomi-cart__line.is-free-gift[data-gift-type='hat'], .naomi-cart__line.is-free-gift:not([data-gift-type]), .naomi-cart__line[data-pending-free-gift='true'][data-gift-type='hat'], .naomi-cart__line[data-pending-free-gift='true']:not([data-gift-type])";
}

function optimisticRemovedGiftSelector(type) {
  return giftLineSelector(type)
    .split(",")
    .map((selector) => `${selector.trim()}[data-optimistic-gift-removed='true']`)
    .join(", ");
}

function hasGiftLineInDom(type, root = getRoot()) {
  return Boolean(root?.querySelector(giftLineSelector(type)));
}

function rewardsMessageHtml(root, qualifyingSubtotal) {
  const config = getConfig();
  const scrubGiftAmount = scrubGiftProgressAmount(root, qualifyingSubtotal);
  const tiers = rewardTierDefinitions(root, qualifyingSubtotal, config, scrubGiftAmount);
  const nextTier = tiers.find(({ amount, threshold }) => amount < threshold);

  if (nextTier) {
    const note = nextTier.type === "shipping" && !isCanadaMarket(root)
      ? '<span class="naomi-cart__reward-note">continental u.s.</span>'
      : "";
    return `<span class="naomi-cart__reward-main">Spend ${formatCartMoney(nextTier.threshold - nextTier.amount)} more for ${nextTier.label}</span>${note}`;
  }

  return '<span class="naomi-cart__reward-main">Free gifts and free shipping unlocked</span>';
}

function ensureRewardsSection(root = getRoot()) {
  if (!root) return undefined;

  const existingRewards = root.querySelector(".naomi-cart__rewards");
  if (existingRewards) return existingRewards;

  const qualifyingSubtotal = centsFromDataset(root, "qualifyingSubtotal");
  const rewards = document.createElement("section");

  rewards.className = "naomi-cart__rewards";
  rewards.setAttribute("aria-label", "Cart rewards");
  rewards.innerHTML = `
    <div class="naomi-cart__progress" aria-hidden="true">
      ${rewardProgressHtml(root, qualifyingSubtotal)}
    </div>
    <p>${rewardsMessageHtml(root, qualifyingSubtotal)}</p>
  `;

  root.querySelector(".naomi-cart__head")?.after(rewards);
  return rewards;
}

function syncRewardStateForActiveCurrency(root = getRoot()) {
  const rewards = root?.querySelector(".naomi-cart__rewards");
  if (!(root instanceof HTMLElement) || !rewards) return;

  const qualifyingSubtotal = centsFromDataset(root, "qualifyingSubtotal");
  const cartTotal = centsFromDataset(root, "cartTotal");
  syncRewardProgress(root, qualifyingSubtotal, cartTotal);

  const rewardText = rewards.querySelector("p");
  if (rewardText) rewardText.innerHTML = rewardsMessageHtml(root, qualifyingSubtotal);
}

function normalizedImagePath(image) {
  const source = image?.currentSrc || image?.src || image?.getAttribute?.("src");
  if (!source) return undefined;

  try {
    return new URL(source, window.location.origin).pathname;
  } catch (error) {
    return source.split("?")[0];
  }
}

function cartImageKeys(image) {
  const line = image?.closest?.(".naomi-cart__line");
  return [
    line?.dataset.lineKey && `line:${line.dataset.lineKey}`,
    line?.dataset.variantId && `variant:${normalizeId(line.dataset.variantId)}`,
    line?.dataset.pendingVariantId && `variant:${normalizeId(line.dataset.pendingVariantId)}`,
    line?.dataset.productHandle && `handle:${line.dataset.productHandle}`,
    image?.alt && `alt:${compactText(image.alt).toLowerCase()}`,
    normalizedImagePath(image) && `src:${normalizedImagePath(image)}`,
  ].filter(Boolean);
}

function preserveLoadedCartImages(current, next) {
  if (!current || !next) return;

  const currentImages = [...current.querySelectorAll(".naomi-cart__line-image, .naomi-cart__recommendation-image img")];
  const imagesByKey = new Map();
  currentImages.forEach((image) => {
    const isRecommendationImage = Boolean(image.closest(".naomi-cart__recommendation-image"));
    if (!isRecommendationImage && (!image.complete || image.naturalWidth <= 0)) return;
    cartImageKeys(image).forEach((key) => {
      if (!imagesByKey.has(key)) imagesByKey.set(key, image);
    });
  });

  const usedImages = new Set();
  next.querySelectorAll(".naomi-cart__line-image, .naomi-cart__recommendation-image img").forEach((image) => {
    image.loading = "eager";
    image.decoding = "async";
    if (!(image instanceof HTMLImageElement)) return;

    const replacement = cartImageKeys(image)
      .map((key) => imagesByKey.get(key))
      .find((candidate) => (
        candidate instanceof HTMLImageElement &&
        candidate.complete &&
        candidate.naturalWidth > 0 &&
        !usedImages.has(candidate)
      ));

    if (!replacement) return;
    usedImages.add(replacement);
    replacement.className = image.className;
    replacement.alt = image.alt;
    image.replaceWith(replacement);
  });
}

function syncPreservedLineControls(preservedLine, nextLine) {
  if (!(preservedLine instanceof HTMLElement) || !(nextLine instanceof HTMLElement)) return;

  preservedLine.className = nextLine.className;
  [...preservedLine.attributes]
    .filter((attribute) => attribute.name.startsWith("data-") || attribute.name === "aria-label")
    .forEach((attribute) => preservedLine.removeAttribute(attribute.name));
  [...nextLine.attributes]
    .filter((attribute) => attribute.name.startsWith("data-") || attribute.name === "aria-label")
    .forEach((attribute) => preservedLine.setAttribute(attribute.name, attribute.value));
  preservedLine.hidden = nextLine.hidden;
  preservedLine.style.height = "";
  preservedLine.style.overflow = "";
  preservedLine.style.opacity = "";

  const preservedControls = preservedLine.querySelectorAll("[data-naomi-cart-quantity], [data-naomi-cart-selling-plan-button], [data-naomi-cart-selling-plan]");
  const nextControls = nextLine.querySelectorAll("[data-naomi-cart-quantity], [data-naomi-cart-selling-plan-button], [data-naomi-cart-selling-plan]");
  preservedControls.forEach((control, index) => {
    const nextControl = nextControls[index];
    if (!(control instanceof HTMLElement) || !(nextControl instanceof HTMLElement)) return;
    [...control.attributes]
      .filter((attribute) => attribute.name.startsWith("data-") || attribute.name === "aria-label" || attribute.name === "disabled")
      .forEach((attribute) => control.removeAttribute(attribute.name));
    [...nextControl.attributes]
      .filter((attribute) => attribute.name.startsWith("data-") || attribute.name === "aria-label" || attribute.name === "disabled")
      .forEach((attribute) => control.setAttribute(attribute.name, attribute.value));
  });
}

function preserveStableRewardRows(current, next) {
  if (!current || !next) return;

  ["scrub", "hat", "shipping"].forEach((type) => {
    const currentLine = current.querySelector(giftLineSelector(type));
    const nextLine = next.querySelector(giftLineSelector(type));
    if (!(currentLine instanceof HTMLElement) || !(nextLine instanceof HTMLElement)) return;
    if (currentLine.classList.contains("is-pending") || currentLine.classList.contains("is-removing")) return;

    syncPreservedLineControls(currentLine, nextLine);
    currentLine.classList.remove("is-entering", "is-gift-unlocking");
    nextLine.replaceWith(currentLine);
  });
}

function visibleRewardTypes(root) {
  if (!root) return new Set();

  return new Set(
    ["scrub", "hat", "shipping"].filter((type) => {
      const line = root.querySelector(giftLineSelector(type));
      return line instanceof HTMLElement && !line.hidden && !line.classList.contains("is-removing");
    }),
  );
}

function preserveCartFadeState(current, next) {
  if (!(current instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

  ["is-cart-scrollable", "is-cart-scrolled-bottom"].forEach((className) => {
    next.classList.toggle(className, current.classList.contains(className));
  });

  const bottomHeight = current.style.getPropertyValue("--naomi-cart-bottom-height");
  if (bottomHeight) {
    next.style.setProperty("--naomi-cart-bottom-height", bottomHeight);
  }

  next.classList.add("is-cart-layout-settling");
}

function clearCartFadeSettling(root = getRoot()) {
  root?.classList.remove("is-cart-layout-settling");
}

function optimisticallyRemoveLine(line, { removeFromDom = false } = {}) {
  if (!(line instanceof HTMLElement) || line.classList.contains("is-removing")) return;

  const removalToken = `${Date.now()}-${Math.random()}`;
  line.dataset.optimisticRemovalToken = removalToken;
  line.style.height = `${line.getBoundingClientRect().height}px`;
  line.style.overflow = "hidden";
  line.getBoundingClientRect();
  line.classList.add("is-removing");

  window.requestAnimationFrame(() => {
    line.style.height = "0px";
    scheduleCartLayoutUpdate();
  });

  window.setTimeout(() => {
    if (line.dataset.optimisticRemovalToken === removalToken && line.classList.contains("is-removing")) {
      if (removeFromDom) {
        line.remove();
      } else {
        line.hidden = true;
      }
      scheduleCartLayoutUpdate();
    }
  }, 220);
}

function isMerchandiseCartLine(line) {
  if (!(line instanceof HTMLElement)) return false;
  if (line.hidden || line.classList.contains("is-removing")) return false;
  if (line.classList.contains("is-free-gift")) return false;
  if (line.matches("[data-naomi-shipping-reward-line]")) return false;
  if (line.dataset.pendingFreeGift === "true") return false;

  const quantity = Number(line.dataset.currentQuantity || line.dataset.confirmedQuantity || 1);
  return Number.isFinite(quantity) && quantity > 0;
}

function hasVisibleMerchandiseLines(root = getRoot(), { excludingLine } = {}) {
  if (!root) return false;

  return [...root.querySelectorAll(".naomi-cart__line")].some((line) => (
    line !== excludingLine && isMerchandiseCartLine(line)
  ));
}

function optimisticEmptyRecommendationsHtml(root = getRoot()) {
  const currentRecommendations = root?.querySelector("[data-naomi-recommendations]");
  if (!currentRecommendations) return "";

  const recommendations = currentRecommendations.cloneNode(true);
  recommendations.classList.add("naomi-cart__recommendations--empty");
  recommendations.classList.remove("is-stacked");

  const heading = recommendations.querySelector(".naomi-cart__recommendation-head span");
  if (heading) heading.textContent = "You may like";

  applyRecommendationIndex(recommendations, 0);
  return recommendations.outerHTML;
}

function optimisticEmptyCartHtml(root = getRoot()) {
  return `
    <section class="naomi-cart__empty" aria-label="Empty cart">
      <div class="naomi-cart__empty-main">
        <h3>Your cart is empty</h3>
        <p>2% of net sales support World Central Kitchen.</p>
        <a href="https://trynaomi.com/pages/shop-everything">Shop all</a>
      </div>
      ${optimisticEmptyRecommendationsHtml(root)}
    </section>
  `;
}

function showOptimisticEmptyCart(root = getRoot()) {
  if (!root) return;

  root.dataset.cartTotal = "0";
  root.dataset.qualifyingSubtotal = "0";
  root.dataset.cartItemCount = "0";

  root.classList.add("is-empty", "naomi-cart__inner--empty");
  root.classList.remove(
    "has-items",
    "is-awaiting-cart",
    "is-cart-scrollable",
    "is-cart-scrolled-bottom",
    "is-gift-unlocking",
  );
  root.style.removeProperty("--naomi-cart-bottom-height");

  root.querySelector(".naomi-cart__rewards")?.remove();
  root.querySelector(".naomi-cart__items")?.remove();
  root.querySelector(".naomi-cart__bottom")?.remove();
  root.querySelector(".naomi-cart__empty")?.remove();
  root.querySelector(".naomi-cart__head")?.insertAdjacentHTML("afterend", optimisticEmptyCartHtml(root));

  initCarousel();
  scheduleCartLayoutUpdate();
}

function pendingStepperHtml(product = {}, quantity = 1) {
  const title = product.title || "Product";
  const giftType = product.giftType || "hat";
  const disabledPlusLabel = product.isFreeGift ? "Free gift quantity cannot be increased" : "Increase quantity";
  const giftAttributes = product.isFreeGift ? ` data-free-gift="true" data-gift-type="${escapeHtml(giftType)}"` : "";
  const disabledAttributes = product.isFreeGift ? " disabled" : " disabled aria-disabled=\"true\"";

  return `
    <div class="naomi-cart__stepper" aria-label="${escapeHtml(title)} quantity">
      <button type="button" tabindex="-1" aria-label="Decrease quantity"${giftAttributes}${product.isFreeGift ? "" : " disabled aria-disabled=\"true\""}>-</button>
      <span>${quantity}</span>
      <button type="button" tabindex="-1" aria-label="${escapeHtml(disabledPlusLabel)}"${giftAttributes}${disabledAttributes}>+</button>
    </div>
  `;
}

function syncOptimisticShippingLine(previousQualifyingSubtotal, qualifyingSubtotal) {
  const root = getRoot();
  if (!root) return;

  const shippingLine = root.querySelector("[data-naomi-shipping-reward-line]");
  if (shippingLine instanceof HTMLElement) optimisticallyRemoveLine(shippingLine, { removeFromDom: true });
}

function restoreOptimisticallyRemovedLine(line) {
  if (!(line instanceof HTMLElement)) return;

  delete line.dataset.optimisticRemovalToken;
  delete line.dataset.optimisticGiftRemoved;
  line.hidden = false;
  line.classList.remove("is-removing");
  line.style.height = "";
  line.style.overflow = "";
  line.style.opacity = "";
  scheduleCartLayoutUpdate();
}

function syncOptimisticGiftLine(previousQualifyingSubtotal, qualifyingSubtotal, previousScrubGiftAmount = previousQualifyingSubtotal, scrubGiftAmount = qualifyingSubtotal) {
  const root = getRoot();
  if (!root) return;

  const config = getConfig();

  [
    { threshold: config.freeGiftThreshold, type: "hat" },
    { threshold: config.scrubGiftThreshold, type: "scrub" },
  ].forEach(({ threshold, type }) => {
    const giftLine = root.querySelector(giftLineSelector(type));
    const pendingGiftLine = root.querySelector(`.naomi-cart__line[data-pending-free-gift='true'][data-gift-type='${type}']`);
    const previousAmount = type === "scrub" ? previousScrubGiftAmount : previousQualifyingSubtotal;
    const currentAmount = type === "scrub" ? scrubGiftAmount : qualifyingSubtotal;
    const movedBelowGiftThreshold = previousAmount >= threshold && currentAmount < threshold;

    if (movedBelowGiftThreshold) {
      if (giftLine instanceof HTMLElement) {
        giftLine.dataset.optimisticGiftRemoved = "true";
        optimisticallyRemoveLine(giftLine);
      }

      if (pendingGiftLine instanceof HTMLElement && pendingGiftLine !== giftLine) {
        optimisticallyRemoveLine(pendingGiftLine);
      }

      return;
    }

    if (currentAmount >= threshold) {
      const removedGiftLine = root.querySelector(optimisticRemovedGiftSelector(type));
      restoreOptimisticallyRemovedLine(removedGiftLine);
    }
  });
}

function updateRecommendationDisplayMode(root, bottom) {
  const recommendations = root.querySelector("[data-naomi-recommendations]");
  const items = root.querySelector(".naomi-cart__items");
  const cards = recommendations?.querySelectorAll("[data-naomi-recommendation-card]");

  if (!recommendations || !items || !bottom || !cards || cards.length < 2) {
    recommendations?.classList.remove("is-stacked");
    return;
  }

  recommendations.classList.remove("is-stacked");

  const isFirstOptimisticAdd =
    bottom.dataset.naomiOptimisticBottom === "true" &&
    items.classList.contains("naomi-cart__items--pending") &&
    [...items.querySelectorAll(".naomi-cart__line")].filter(isMerchandiseCartLine).length <= 1;

  if (isFirstOptimisticAdd) {
    recommendations.classList.add("is-stacked");
    root.style.setProperty("--naomi-cart-bottom-height", `${Math.ceil(bottom.getBoundingClientRect().height)}px`);
    return;
  }

  const firstCardHeight = cards[0]?.getBoundingClientRect().height || 96;
  const extraCardSpace = firstCardHeight + 8;
  const bottomHeight = Math.ceil(bottom.getBoundingClientRect().height);
  const lineContentHeight = [...items.children].reduce((height, child) => {
    if (!(child instanceof HTMLElement)) return height;
    return height + child.getBoundingClientRect().height;
  }, 0);
  const requiredHeightWithStack = lineContentHeight + bottomHeight + extraCardSpace + 12;

  root.style.setProperty("--naomi-cart-bottom-height", `${bottomHeight}px`);
  recommendations.classList.toggle("is-stacked", items.clientHeight >= requiredHeightWithStack);
}

function cartScrollSnapshot(root = getRoot()) {
  const items = root?.querySelector(".naomi-cart__items");
  if (!(items instanceof HTMLElement)) return undefined;

  return {
    distanceFromBottom: items.scrollHeight - items.clientHeight - items.scrollTop,
    top: items.scrollTop,
    wasNearBottom: items.scrollHeight - items.clientHeight - items.scrollTop < 4,
  };
}

function restoreCartScroll(snapshot, root = getRoot()) {
  const items = root?.querySelector(".naomi-cart__items");
  if (!snapshot || !(items instanceof HTMLElement)) return;

  const maxTop = Math.max(0, items.scrollHeight - items.clientHeight);
  const targetTop = snapshot.wasNearBottom
    ? Math.max(0, maxTop - snapshot.distanceFromBottom)
    : Math.min(snapshot.top, maxTop);

  items.scrollTop = targetTop;
  updateCartItemsScrollState(items);
}

function scheduleCartScrollRestore(snapshot) {
  restoreCartScroll(snapshot);

  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(() => {
      restoreCartScroll(snapshot);
      window.requestAnimationFrame(() => restoreCartScroll(snapshot));
    });
  }

  window.setTimeout(() => restoreCartScroll(snapshot), 120);
}

async function renderCartSection(sections) {
  if (hasPendingLineChanges()) {
    scheduleRefresh();
    return;
  }

  const { sectionId } = getConfig();
  const current = getRoot();
  const currentRecommendation = current?.querySelector("[data-naomi-recommendations]");
  const preservedRecommendationIndex = state.carouselInteracted ? activeRecommendationIndex(currentRecommendation) : 0;
  const scrollSnapshot = cartScrollSnapshot(current);
  const visibleRewardsBeforeRefresh = visibleRewardTypes(current);
  const previousQualifyingSubtotal = centsFromDataset(current, "qualifyingSubtotal");
  const previousCartTotal = centsFromDataset(current, "cartTotal");
  const existingDealBannerLineKeys = visibleDealBannerLineKeys(current);
  const renderedSections =
    sections || (await shopifyFetch(`?sections=${sectionId}&sections_url=${encodeURIComponent(window.location.pathname)}`));
  const html = renderedSections[sectionId];

  if (!html) return;

  const parsed = new DOMParser().parseFromString(html, "text/html");
  const next = parsed.querySelector("[data-naomi-cart]");
  const nextQualifyingSubtotal = centsFromDataset(next, "qualifyingSubtotal");
  const nextCartTotal = centsFromDataset(next, "cartTotal");
  suppressConfirmedDealBannerAnimations(next, existingDealBannerLineKeys);
  preserveStableRewardRows(current, next);
  preserveCartFadeState(current, next);

  if (getDialog()?.open) stopDrawerOpenChoreography();

  if (current && next) {
    preserveLoadedCartImages(current, next);
    current.replaceWith(next);
  } else if (current) {
    current.innerHTML = html;
  }

  moveGiftLinesToBottom();
  syncRewardStateForActiveCurrency(getRoot());
  updateRecommendationRewardHeading(getRoot());

  const shippingThreshold = freeShippingThreshold(next);
  if (previousQualifyingSubtotal < shippingThreshold && nextQualifyingSubtotal >= shippingThreshold && getDialog()?.open && !visibleRewardsBeforeRefresh.has("shipping")) {
    startGiftUnlockMoment(getRoot(), "shipping");
  }

  if (shouldAnimateConfirmedProgressMessage(previousQualifyingSubtotal, nextQualifyingSubtotal, getRoot(), previousCartTotal, nextCartTotal) && getDialog()?.open) {
    animateRewardMessage(getRoot());
  }

  if (state.pendingGiftUnlockMoment) {
    const shouldPlayPendingGiftUnlock = state.pendingGiftUnlockType && !visibleRewardsBeforeRefresh.has(state.pendingGiftUnlockType);
    state.pendingGiftUnlockMoment = false;
    if (shouldPlayPendingGiftUnlock) startGiftUnlockMoment(getRoot(), state.pendingGiftUnlockType);
    state.pendingGiftUnlockType = undefined;
  }

  const nextRecommendation = getRoot()?.querySelector("[data-naomi-recommendations]");
  if (nextRecommendation && getDialog()?.open) {
    applyRecommendationIndex(nextRecommendation, preservedRecommendationIndex);
  }

  initCarousel();
  scheduleCartScrollRestore(scrollSnapshot);
  scheduleCartLayoutUpdate();
}

async function reconcileCartMutation(
  response,
  {
    clearPendingKeys = [],
    clearPendingPrefixes = [],
    forceClearPendingKeys = [],
    forceClearPendingPrefixes = [],
    open = false,
  } = {},
) {
  let cart = response;
  const responseSections = response?.sections;

  if (!cart?.items || cart.item_count === undefined) {
    cart = await shopifyFetch("cart.js");
  }

  if (hasUnconfirmedLineQuantityIntents(cart)) {
    state.quantitySettledAt = Math.max(state.quantitySettledAt, Date.now() + QUANTITY_RENDER_SETTLE_MS);
    scheduleRefresh();
    return cart;
  }

  const syncedCart = await syncFreeGift(cart);
  if (syncedCart !== cart) {
    if (syncedCart?.sections) await renderCartSection(syncedCart.sections);
    cart = syncedCart?.items && syncedCart.item_count !== undefined ? syncedCart : await shopifyFetch("cart.js");
    if (!syncedCart?.sections) await renderCartSection();
  } else if (responseSections) {
    await renderCartSection(responseSections);
  } else if (!response?.sections) {
    await renderCartSection();
  }

  dispatchHorizonCartUpdate(cart, {
    clearPendingKeys,
    clearPendingPrefixes,
    forceClearPendingKeys,
    forceClearPendingPrefixes,
  });
  if (open) openCart();

  return cart;
}

function updateCartLayoutState() {
  updateCartViewportMetrics();

  document.querySelectorAll("[data-naomi-cart]").forEach((root) => {
    const bottom = root.querySelector(".naomi-cart__bottom");
    if (bottom instanceof HTMLElement) {
      updateRecommendationDisplayMode(root, bottom);
    }

    if (bottom instanceof HTMLElement) {
      root.style.setProperty("--naomi-cart-bottom-height", `${Math.ceil(bottom.getBoundingClientRect().height)}px`);
    } else {
      root.style.removeProperty("--naomi-cart-bottom-height");
    }
  });

  document.querySelectorAll(".naomi-cart__items").forEach((items) => {
    updateCartItemsScrollState(items);
  });
}

function updateCartViewportMetrics() {
  const shouldUseVisualViewport = window.matchMedia?.("(max-width: 749px)")?.matches;
  if (!shouldUseVisualViewport || !window.visualViewport) {
    if (state.cartViewportHeight !== undefined) {
      document.documentElement.style.removeProperty("--naomi-cart-visual-viewport-height");
      state.cartViewportHeight = undefined;
    }
    if (state.cartViewportTop !== undefined) {
      document.documentElement.style.removeProperty("--naomi-cart-visual-viewport-top");
      state.cartViewportTop = undefined;
    }
    return;
  }

  const height = Math.max(320, Math.floor(window.visualViewport.height));
  const top = Math.max(0, Math.floor(window.visualViewport.offsetTop || 0));
  if (height !== state.cartViewportHeight) {
    document.documentElement.style.setProperty("--naomi-cart-visual-viewport-height", `${height}px`);
    state.cartViewportHeight = height;
  }
  if (top !== state.cartViewportTop) {
    document.documentElement.style.setProperty("--naomi-cart-visual-viewport-top", `${top}px`);
    state.cartViewportTop = top;
  }
}

function scheduleOpenCartLayoutUpdate() {
  if (!getDialog()?.open && !document.documentElement.hasAttribute("data-naomi-cart-open")) return;
  scheduleCartLayoutUpdate();
}

function appendPendingLine(product = {}) {
  const root = getRoot();
  if (!root) return;

  const pendingProduct = product.isSubscription ? { ...product, isSubscribable: false } : product;
  const rewards = ensureRewardsSection(root);
  let items = root.querySelector(".naomi-cart__items");
  if (!items) {
    items = document.createElement("div");
    items.className = "naomi-cart__items naomi-cart__items--pending";
    (rewards || root.querySelector(".naomi-cart__head"))?.after(items);
  }

  const pendingCountKey = pendingProduct.pendingCountKey;
  if (pendingCountKey && state.optimisticMergedAddKeys.has(pendingCountKey)) {
    root.classList.add("has-items", "is-awaiting-cart");
    root.classList.remove("is-empty", "naomi-cart__inner--empty");
    root.querySelector(".naomi-cart__empty")?.setAttribute("hidden", "");
    scheduleCartLayoutUpdate();
    return;
  }

  const existingLine = existingLineForPendingProduct(items, pendingProduct);
  if (existingLine && !pendingProduct.isFreeGift) {
    incrementExistingLineOptimistically(existingLine, pendingProduct);
    if (pendingCountKey) state.optimisticMergedAddKeys.add(pendingCountKey);
    root.classList.add("has-items", "is-awaiting-cart");
    root.classList.remove("is-empty", "naomi-cart__inner--empty");
    root.querySelector(".naomi-cart__empty")?.setAttribute("hidden", "");
    scheduleCartLayoutUpdate();
    return;
  }

  const existingPendingLine = pendingCountKey
    ? items.querySelector(`.naomi-cart__line.is-pending[data-pending-add-key="${escapeCssIdentifier(pendingCountKey)}"]`)
    : items.querySelector(`.naomi-cart__line.is-pending${pendingProduct.variantId ? `[data-pending-variant-id="${escapeCssIdentifier(pendingProduct.variantId)}"]` : ""}`);
  if (existingPendingLine) {
    root.classList.add("has-items", "is-awaiting-cart");
    root.classList.remove("is-empty", "naomi-cart__inner--empty");
    root.querySelector(".naomi-cart__empty")?.setAttribute("hidden", "");
    scheduleCartLayoutUpdate();
    return;
  }

  const pendingLine = document.createElement("article");
  const hasProductData = Boolean(cleanOptimisticProductTitle(pendingProduct.title));
  pendingLine.className = `naomi-cart__line is-pending is-entering${hasProductData ? " is-optimistic" : ""}${pendingProduct.isFreeGift ? " is-free-gift is-gift-unlocking" : ""}`;
  pendingLine.setAttribute("aria-label", "Adding product to cart");
  if (pendingCountKey) pendingLine.dataset.pendingAddKey = String(pendingCountKey);
  if (pendingProduct.variantId) pendingLine.dataset.pendingVariantId = String(pendingProduct.variantId);
  if (pendingProduct.handle || pendingProduct.productHandle) pendingLine.dataset.productHandle = pendingProduct.handle || pendingProduct.productHandle;
  if (pendingProduct.isFreeGift) {
    pendingLine.dataset.pendingFreeGift = "true";
    pendingLine.dataset.giftType = pendingProduct.giftType || "hat";
  }

  const quantity = Math.max(1, Number(pendingProduct.quantity) || 1);
  const linePrice = optimisticPendingLinePrice(pendingProduct, quantity);
  const pendingSubscribeLabel = subscribeButtonLabelForProduct(pendingProduct, quantity);

  pendingLine.innerHTML = hasProductData ? `
    <div class="naomi-cart__line-grid">
      ${pendingProduct.image ? (
        pendingProduct.isFreeGift
          ? `<span aria-hidden="true"><img class="naomi-cart__line-image" src="${escapeHtml(pendingProduct.image)}" alt="${escapeHtml(pendingProduct.title || "Product image")}" loading="eager"></span>`
          : `<img class="naomi-cart__line-image" src="${escapeHtml(pendingProduct.image)}" alt="${escapeHtml(pendingProduct.title || "Product image")}" loading="eager">`
      ) : `<span class="naomi-cart__pending-block naomi-cart__pending-image"></span>`}
      <div class="naomi-cart__line-main">
        <div class="naomi-cart__line-title">
          <div>
            <h3>${escapeHtml(pendingProduct.title)}</h3>
            ${pendingProduct.subtitle || pendingProduct.isSubscription ? `
              <p class="naomi-cart__meta-list">
                ${pendingProduct.subtitle ? `<span class="naomi-cart__meta-text">${escapeHtml(pendingProduct.subtitle)}</span>` : ""}
                ${pendingProduct.isSubscription ? `
                  <span class="naomi-cart__meta-item naomi-cart__meta-item--subscription">
                    ${pendingProduct.subtitle ? `<span class="naomi-cart__meta-separator" aria-hidden="true">&bull;</span>` : ""}
                    <span>Subscription</span>
                  </span>
                ` : ""}
              </p>
            ` : ""}
          </div>
          ${linePrice !== undefined ? `<strong>${formatCartMoney(linePrice)}</strong>` : `<span class="naomi-cart__pending-block naomi-cart__pending-price"></span>`}
        </div>
        <div class="naomi-cart__line-actions">
          ${pendingStepperHtml(pendingProduct, quantity)}
          ${pendingProduct.isSubscribable ? `<button class="naomi-cart__subscribe naomi-cart__subscribe--pending" type="button" tabindex="-1">${escapeHtml(pendingSubscribeLabel)}</button>` : ""}
        </div>
      </div>
    </div>
  ` : `
    <div class="naomi-cart__line-grid">
      <span class="naomi-cart__pending-block naomi-cart__pending-image"></span>
      <span class="naomi-cart__line-main">
        <span class="naomi-cart__pending-row">
          <span class="naomi-cart__pending-block naomi-cart__pending-title"></span>
          <span class="naomi-cart__pending-block naomi-cart__pending-price"></span>
        </span>
        <span class="naomi-cart__pending-block naomi-cart__pending-meta"></span>
        <span class="naomi-cart__pending-block naomi-cart__pending-stepper"></span>
      </span>
    </div>
  `;

  items.prepend(pendingLine);
  moveGiftLinesToBottom(root);
  root.classList.add("has-items", "is-awaiting-cart");
  root.classList.remove("is-empty", "naomi-cart__inner--empty");
  root.querySelector(".naomi-cart__empty")?.setAttribute("hidden", "");
  if (linePrice) updateOptimisticCartSummary(linePrice, linePrice);
  scheduleCartLayoutUpdate();
}

function existingLineForPendingProduct(items, product = {}) {
  if (!items || product.isFreeGift) return undefined;

  const pendingVariantId = normalizeId(product.variantId);
  const pendingHandle = compactText(product.handle || product.productHandle || "");
  const pendingIsSubscription = product.isSubscription ? "true" : "false";

  return [...items.querySelectorAll(".naomi-cart__line:not(.is-pending):not(.is-free-gift)")].find((line) => {
    if (!(line instanceof HTMLElement)) return false;
    if (line.dataset.isSubscription !== pendingIsSubscription) return false;
    if (pendingVariantId && normalizeId(line.dataset.variantId) === pendingVariantId) return true;
    if (pendingHandle && line.dataset.productHandle === pendingHandle) return true;

    return false;
  });
}

function buyThreeDiscountPercentForLine(line, trigger) {
  if (!(line instanceof HTMLElement)) return 0;
  if (line.dataset.isSubscription === "true") return 0;
  if (compactText(line.dataset.productHandle || "") === "la-terroir-candle") return 0;

  return Number(
    trigger?.dataset?.naomiBuyThreeDiscount ||
      line.dataset.naomiBuyThreeDiscount ||
      line.querySelector("[data-naomi-buy-three-discount]")?.dataset.naomiBuyThreeDiscount ||
      0,
  );
}

function buyThreeDiscountPercentForProduct(product = {}) {
  const handle = compactText(product.handle || product.productHandle || "");
  if (handle === "la-terroir-candle") return 0;

  return ["003", "005", "006", "002", "001"].includes(String(product.sku || "").trim()) ? 15 : 0;
}

function subscribeButtonLabelForDiscountState(discountPercent, quantity) {
  return discountPercent > 0 && Number(quantity) >= 3 ? "Subscribe" : "Subscribe to save 15%";
}

function subscribeButtonLabelForProduct(product = {}, quantity = product.quantity) {
  return subscribeButtonLabelForDiscountState(buyThreeDiscountPercentForProduct(product), quantity);
}

function updateOptimisticSubscribeButtonLabel(line, quantity, trigger) {
  if (!(line instanceof HTMLElement) || line.dataset.isSubscription === "true") return;

  const button = line.querySelector("[data-naomi-cart-selling-plan-button], .naomi-cart__subscribe--pending");
  if (!(button instanceof HTMLElement)) return;

  button.textContent = subscribeButtonLabelForDiscountState(buyThreeDiscountPercentForLine(line, trigger), quantity);
}

function discountedUnitPrice(unitOriginalPrice, discountPercent) {
  return Math.round(unitOriginalPrice * ((100 - discountPercent) / 100));
}

function baseUnitPriceForLineQuantity(unitOriginalPrice, unitFinalPrice, buyThreeDiscountPercent) {
  const isLikelyBuyThreeUnit =
    buyThreeDiscountPercent > 0 &&
    Math.abs(unitFinalPrice - discountedUnitPrice(unitOriginalPrice, buyThreeDiscountPercent)) <= 1;

  if (unitFinalPrice > 0 && unitFinalPrice < unitOriginalPrice && !isLikelyBuyThreeUnit) return unitFinalPrice;
  return unitOriginalPrice;
}

function optimisticLineFinalPriceForQuantity(line, quantity, trigger) {
  const safeQuantity = Math.max(0, Number(quantity) || 0);
  if (!safeQuantity) return 0;

  const unitFinalPrice = centsFromDataset(line, "unitFinalPrice");
  const unitOriginalPrice = centsFromDataset(line, "unitOriginalPrice") || unitFinalPrice;
  const buyThreeDiscountPercent = buyThreeDiscountPercentForLine(line, trigger);
  const isSubscriptionLine = line?.dataset.isSubscription === "true";

  if (isSubscriptionLine) {
    const subscriptionUnitPrice = discountedUnitPrice(unitOriginalPrice, 15);
    return subscriptionUnitPrice * safeQuantity;
  }

  if (buyThreeDiscountPercent > 0 && safeQuantity >= 3) {
    return Math.round(unitOriginalPrice * safeQuantity * ((100 - buyThreeDiscountPercent) / 100));
  }

  return baseUnitPriceForLineQuantity(unitOriginalPrice, unitFinalPrice, buyThreeDiscountPercent) * safeQuantity;
}

function optimisticPendingLinePrice(product = {}, quantity = product.quantity) {
  const safeQuantity = Math.max(1, Number(quantity) || 1);
  let unitPrice = Number(product.price);
  if (!Number.isFinite(unitPrice)) return undefined;

  const discountPercent = product.isSubscription
    ? 0
    : Number(product.buyThreeDiscountPercent) || buyThreeDiscountPercentForProduct(product);
  if (product.isSubscription && product.priceIncludesSubscriptionDiscount === false) {
    unitPrice = discountedUnitPrice(unitPrice, 15);
  }

  if (discountPercent > 0 && safeQuantity >= 3) {
    return Math.round(unitPrice * safeQuantity * ((100 - discountPercent) / 100));
  }

  return unitPrice * safeQuantity;
}

function incrementExistingLineOptimistically(line, product = {}) {
  if (!(line instanceof HTMLElement)) return;

  const quantityDelta = Math.max(1, Number(product.quantity) || 1);
  const currentQuantity = Number(line.dataset.currentQuantity || line.dataset.confirmedQuantity || 0);
  const nextQuantity = currentQuantity + quantityDelta;
  const previousLineFinalPrice = centsFromDataset(line, "lineFinalPrice");
  const unitOriginalPrice = centsFromDataset(line, "unitOriginalPrice") || centsFromDataset(line, "unitFinalPrice");
  const nextLineOriginalPrice = unitOriginalPrice * nextQuantity;
  const nextLineFinalPrice = optimisticLineFinalPriceForQuantity(line, nextQuantity);

  line.classList.add("is-updating");
  line.dataset.currentQuantity = String(nextQuantity);
  line.dataset.lineFinalPrice = String(nextLineFinalPrice);
  line.dataset.lineOriginalPrice = String(nextLineOriginalPrice);
  const quantityText = line.querySelector(".naomi-cart__stepper span");
  if (quantityText) quantityText.textContent = String(nextQuantity);
  line.querySelectorAll("[data-naomi-cart-quantity]").forEach((quantityButton) => {
    const isIncrement = quantityButton.getAttribute("aria-label")?.toLowerCase().includes("increase");
    quantityButton.dataset.quantity = String(isIncrement ? nextQuantity + 1 : nextQuantity - 1);
  });
  renderLinePrice(line.querySelector(".naomi-cart__line-title strong"), nextLineFinalPrice, nextLineOriginalPrice);
  updateOptimisticBuyThreeBanner(line, nextQuantity);
  updateOptimisticSubscribeButtonLabel(line, nextQuantity);
  updateOptimisticCartSummary(nextLineFinalPrice - previousLineFinalPrice, nextLineFinalPrice - previousLineFinalPrice);
}

function scheduleCartLayoutUpdate() {
  if (typeof window.requestAnimationFrame === "function") {
    if (state.cartLayoutFrame) return;
    state.cartLayoutFrame = window.requestAnimationFrame(() => {
      state.cartLayoutFrame = undefined;
      updateCartLayoutState();
      window.requestAnimationFrame(() => clearCartFadeSettling());
    });
  } else {
    window.setTimeout(() => {
      updateCartLayoutState();
      clearCartFadeSettling();
    }, 0);
  }
}

function updateCartItemsScrollState(items) {
  if (!(items instanceof HTMLElement)) return;

  const root = items.closest("[data-naomi-cart]");
  const isScrollable = items.scrollHeight > items.clientHeight + 1;
  const isAtBottom =
    !isScrollable ||
    items.scrollTop + items.clientHeight >= items.scrollHeight - CART_FADE_VISIBILITY_BUFFER_PX;

  items.classList.toggle("is-scrollable", isScrollable);
  root?.classList.toggle("is-cart-scrollable", isScrollable);
  root?.classList.toggle("is-cart-scrolled-bottom", isAtBottom);
}

function optimisticallySetLineQuantity(button) {
  const line = button.closest(".naomi-cart__line");
  const stepper = button.closest(".naomi-cart__stepper") || line?.querySelector(".naomi-cart__stepper");
  const quantityText = stepper?.querySelector("span");
  const buttons = line?.querySelectorAll("[data-naomi-cart-quantity]");
  const currentQuantity = Number(line?.dataset.currentQuantity || quantityText?.textContent || 0);
  const actionLabel = button.getAttribute("aria-label")?.toLowerCase() || "";
  const quantity = actionLabel.includes("decrease")
    ? Math.max(0, currentQuantity - 1)
    : actionLabel.includes("increase")
      ? currentQuantity + 1
      : Number(button.dataset.quantity);
  if (!Number.isFinite(quantity)) return undefined;

  const currentLineFinalPrice = centsFromDataset(line, "lineFinalPrice");
  const unitOriginalPrice = centsFromDataset(line, "unitOriginalPrice") || centsFromDataset(line, "unitFinalPrice");
  const nextLineOriginalPrice = unitOriginalPrice * Math.max(0, quantity);
  const nextLineFinalPrice = optimisticLineFinalPriceForQuantity(line, quantity, button);

  line?.classList.add("is-updating");

  if (quantity <= 0) {
    const previousFinalPrice = centsFromDataset(line, "lineFinalPrice");
    const root = getRoot();
    const willBeEmpty = line instanceof HTMLElement && !hasVisibleMerchandiseLines(root, { excludingLine: line });
    if (line instanceof HTMLElement) {
      line.style.opacity = "0.45";
      line.dataset.currentQuantity = "0";
      line.dataset.lineFinalPrice = "0";
      line.dataset.lineOriginalPrice = "0";
    }
    if (willBeEmpty) {
      showOptimisticEmptyCart(root);
      return quantity;
    }
    updateOptimisticCartSummary(-previousFinalPrice, -previousFinalPrice);
    optimisticallyRemoveLine(line, { removeFromDom: true });
    return quantity;
  }

  if (quantityText) quantityText.textContent = String(quantity);
  if (line instanceof HTMLElement) {
    line.dataset.currentQuantity = String(quantity);
    line.dataset.lineFinalPrice = String(nextLineFinalPrice);
    line.dataset.lineOriginalPrice = String(nextLineOriginalPrice);
  }

  renderLinePrice(line?.querySelector(".naomi-cart__line-title strong"), nextLineFinalPrice, nextLineOriginalPrice);

  buttons?.forEach((quantityButton) => {
    const isIncrement = quantityButton.getAttribute("aria-label")?.toLowerCase().includes("increase");
    quantityButton.dataset.quantity = String(isIncrement ? quantity + 1 : quantity - 1);
  });

  updateOptimisticBuyThreeBanner(line, quantity);
  updateOptimisticSubscribeButtonLabel(line, quantity, button);

  updateOptimisticCartSummary(
    nextLineFinalPrice - currentLineFinalPrice,
    nextLineFinalPrice - currentLineFinalPrice,
  );

  return quantity;
}

function hasPendingLineChanges() {
  return (
    state.lineChangeTimers.size > 0 ||
    state.pendingLineChangeRequests > 0 ||
    state.lineChangeInFlight.size > 0 ||
    state.lineChangeLatestRequests.size > 0
  );
}

function quantityRenderDelay() {
  const settleDelay = Math.max(0, state.quantitySettledAt - Date.now());
  return Math.max(hasPendingLineChanges() ? QUANTITY_RENDER_SETTLE_MS : 0, settleDelay);
}

function scheduleRefresh(options = {}) {
  window.clearTimeout(state.refreshTimer);
  state.refreshTimer = window.setTimeout(() => {
    if (quantityRenderDelay() > 0) {
      scheduleRefresh(options);
      return;
    }

    refresh(options).catch((error) => console.error("Naomi cart refresh failed", error));
  }, quantityRenderDelay());
}

function scheduleLineChangeFlush(timerKey, delay = QUANTITY_CHANGE_DEBOUNCE_MS) {
  const existing = state.lineChangeTimers.get(timerKey);
  if (existing) window.clearTimeout(existing);

  const timer = window.setTimeout(() => runLatestLineChange(timerKey), delay);
  state.lineChangeTimers.set(timerKey, timer);
}

async function runLatestLineChange(timerKey) {
  state.lineChangeTimers.delete(timerKey);

  if (state.lineChangeInFlight.has(timerKey)) {
    scheduleLineChangeFlush(timerKey, QUANTITY_CHANGE_DEBOUNCE_MS);
    return;
  }

  const request = state.lineChangeLatestRequests.get(timerKey);
  if (!request) return;
  state.lineChangeLatestRequests.delete(timerKey);
  state.lineChangeInFlight.add(timerKey);

  let requestSettled = false;

  try {
    state.pendingLineChangeRequests += 1;
    const response = await changeLine(request.lineIndex, request.quantity, undefined, { lineKey: request.lineKey });
    state.pendingLineChangeRequests = Math.max(0, state.pendingLineChangeRequests - 1);
    requestSettled = true;
    state.quantitySettledAt = Date.now() + QUANTITY_RENDER_SETTLE_MS;

    if (request.isFreeGiftRemoval) setRemovedGift(request.giftType, true, response);
    state.lineChangeInFlight.delete(timerKey);

    if (state.lineChangeLatestRequests.has(timerKey)) {
      updateQueuedLineChangeFromResponse(timerKey, request, response);
      scheduleLineChangeFlush(timerKey, 0);
      return;
    }

    if (request.mutationSeq !== state.cartMutationSeq || hasPendingLineChanges()) {
      scheduleRefresh();
      return;
    }

    await reconcileCartMutation(response, {
      forceClearPendingKeys: [request.pendingCountKey],
      forceClearPendingPrefixes: ["line:"],
    });
  } catch (error) {
    if (!requestSettled) {
      state.pendingLineChangeRequests = Math.max(0, state.pendingLineChangeRequests - 1);
    }
    state.lineChangeInFlight.delete(timerKey);
    console.error("Naomi cart quantity update failed", error);
    clearOptimisticCartCountDelta(request.pendingCountKey);
    if (state.lineChangeLatestRequests.has(timerKey)) {
      const queuedRequest = state.lineChangeLatestRequests.get(timerKey);
      if (queuedRequest) queuedRequest.lineKey = undefined;
      scheduleLineChangeFlush(timerKey, 0);
      return;
    }
    state.pendingLineQuantityIntents.delete(timerKey);
    scheduleRefresh();
  }
}

function updateQueuedLineChangeFromResponse(timerKey, completedRequest, cart) {
  const queuedRequest = state.lineChangeLatestRequests.get(timerKey);
  const lineIndex = Number(completedRequest?.lineIndex);
  const updatedLine = Number.isFinite(lineIndex) ? cart?.items?.[lineIndex - 1] : undefined;
  const updatedLineKey = updatedLine?.key;
  if (!queuedRequest) return;

  queuedRequest.lineKey = updatedLineKey || undefined;

  const currentLine =
    document.querySelector(`.naomi-cart__line[data-naomi-line-queue-key="${escapeCssIdentifier(timerKey)}"]`) ||
    document.querySelector(`.naomi-cart__line[data-line-key="${escapeCssIdentifier(completedRequest.lineKey || "")}"]`);
  if (!updatedLineKey) return;
  const intent = state.pendingLineQuantityIntents.get(timerKey);
  const updatedLineIdentityKey = `line:${updatedLineKey}`;
  if (intent && !intent.identityKeys.includes(updatedLineIdentityKey)) {
    intent.identityKeys.push(updatedLineIdentityKey);
  }
  if (currentLine instanceof HTMLElement) currentLine.dataset.lineKey = updatedLineKey;
  currentLine?.querySelectorAll("[data-naomi-cart-quantity], [data-naomi-cart-selling-plan-button], [data-naomi-cart-selling-plan]").forEach((control) => {
    control.dataset.lineKey = updatedLineKey;
  });
}

function scheduleLineChange(button, quantity) {
  const line = button.closest(".naomi-cart__line");
  const lineIndex = button.dataset.line;
  const lineKey = button.dataset.lineKey || line?.dataset.lineKey;
  if (!lineIndex && !lineKey) return;
  const timerKey = stableLineChangeKey(line, lineIndex, lineKey);
  const previousRequest = state.lineChangeLatestRequests.get(timerKey);
  const pendingCountKey = pendingLineCartCountKey(line, lineIndex);
  const isFreeGiftRemoval = button.dataset.freeGift === "true" && Number(quantity) === 0;
  const giftType = button.dataset.giftType || "hat";

  state.quantitySettledAt = Date.now() + QUANTITY_RENDER_SETTLE_MS;
  const mutationSeq = ++state.cartMutationSeq;
  rememberPendingLineQuantityIntent(timerKey, { line, lineIndex, lineKey, mutationSeq, quantity });

  state.lineChangeLatestRequests.set(timerKey, {
    giftType,
    isFreeGiftRemoval,
    lineIndex,
    lineKey: previousRequest?.lineKey || lineKey,
    mutationSeq,
    pendingCountKey,
    quantity,
  });
  scheduleLineChangeFlush(timerKey);
}

function dispatchHorizonCartUpdate(cart, pendingOptions = {}) {
  state.lastCart = cart;
  if (cart?.items) state.giftQualifyingSubtotal = qualifyingSubtotal(cart);
  syncConfirmedCartCount(cart, {
    ...pendingOptions,
    clearPendingPrefixes: [...(pendingOptions.clearPendingPrefixes || []), "free-gift"],
  });
  pruneResolvedExternalAddState();
  restorePendingExternalAddLines();

  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        data: { itemCount: cart.item_count, source: "naomi-cart" },
        resource: cart,
        sourceId: "naomi-cart",
      },
    }),
  );
  renderHeaderCartCount();
}

function prewarmCart() {
  if (state.prewarmPromise || state.isRefreshing || hasPendingLineChanges()) return;

  state.prewarmPromise = shopifyFetch("cart.js")
    .then((cart) => {
      state.lastCart = cart;
      return cart;
    })
    .catch(() => undefined)
    .finally(() => {
      state.prewarmPromise = undefined;
    });
}

function schedulePrewarmCart() {
  window.clearTimeout(state.prewarmTimer);
  state.prewarmTimer = window.setTimeout(prewarmCart, 80);
}

function clearExternalAddRefreshTimers(key) {
  if (key) {
    (state.externalAddRefreshTimers.get(key) || []).forEach((timer) => window.clearTimeout(timer));
    state.externalAddRefreshTimers.delete(key);
    return;
  }

  state.externalAddRefreshTimers.forEach((timers) => {
    timers.forEach((timer) => window.clearTimeout(timer));
  });
  state.externalAddRefreshTimers.clear();
}

function setExternalAddRefreshTimers(key, timers = []) {
  if (!key) return;
  clearExternalAddRefreshTimers(key);
  state.externalAddRefreshTimers.set(key, timers);
}

function clearExternalAddPending(key, { clearCount = false } = {}) {
  if (!key) return;
  clearExternalAddRefreshTimers(key);
  state.pendingExternalAddProducts.delete(key);
  state.optimisticMergedAddKeys.delete(key);
  state.pendingAnticipatedExternalAdds = state.pendingAnticipatedExternalAdds.filter((add) => add.key !== key);
  state.closedExternalAddKeys.delete(key);
  if (clearCount) clearOptimisticCartCountDelta(key);
  if (state.latestExternalAddKey === key) state.latestExternalAddKey = undefined;
}

function externalAddModeSignature(product = {}) {
  const sellingPlan = normalizeId(product.sellingPlan || product.sellingPlanId);
  if (sellingPlan) return `plan:${sellingPlan}`;
  return product.isSubscription ? "subscription" : "one-time";
}

function externalAddSignature(product = {}) {
  const mode = externalAddModeSignature(product);
  const variantId = normalizeId(product.variantId);
  if (variantId) return `variant:${variantId}:${mode}`;

  const handle = compactText(product.handle || product.productHandle || "");
  if (handle) return `handle:${handle}:${mode}`;

  const title = cleanOptimisticProductTitle(product.title);
  return title ? `title:${title.toLowerCase()}:${mode}` : "";
}

function pruneAnticipatedExternalAdds(now = Date.now()) {
  state.pendingAnticipatedExternalAdds = state.pendingAnticipatedExternalAdds.filter((add) => (
    add.expiresAt > now &&
    state.pendingCartCountDeltas.has(add.key)
  ));
}

function rememberAnticipatedExternalAdd(key, product = {}) {
  if (!key) return;
  pruneAnticipatedExternalAdds();
  state.pendingAnticipatedExternalAdds.push({
    expiresAt: Date.now() + EXTERNAL_ADD_ANTICIPATION_MS,
    key,
    signature: externalAddSignature(product),
  });
}

function consumeAnticipatedExternalAdd(product = {}, quantity = 1) {
  pruneAnticipatedExternalAdds();
  if (state.pendingAnticipatedExternalAdds.length === 0) return undefined;

  const signature = externalAddSignature(product);
  let index = -1;
  if (signature) {
    index = state.pendingAnticipatedExternalAdds.findIndex((add) => add.signature && add.signature === signature);
  }
  if (index < 0 && state.pendingAnticipatedExternalAdds.length === 1) index = 0;
  if (index < 0) return undefined;

  const [anticipatedAdd] = state.pendingAnticipatedExternalAdds.splice(index, 1);
  const existingProduct = state.pendingExternalAddProducts.get(anticipatedAdd.key) || {};
  const requestQuantity = Math.max(1, Number(quantity) || Number(product.quantity) || Number(existingProduct.quantity) || 1);
  const mergedProduct = mergeProductContext(existingProduct, {
    ...product,
    quantity: requestQuantity,
  });
  setOptimisticCartCountDelta(anticipatedAdd.key, requestQuantity, { animate: false });
  if (cleanOptimisticProductTitle(mergedProduct.title)) {
    state.pendingExternalAddProducts.set(anticipatedAdd.key, mergedProduct);
  }
  return anticipatedAdd.key;
}

function unresolvedExternalAddProducts() {
  return [...state.pendingExternalAddProducts.entries()]
    .filter(([key]) => state.pendingCartCountDeltas.has(key))
    .map(([, product]) => product);
}

function unresolvedExternalAddKeys() {
  return [...state.pendingExternalAddProducts.keys()]
    .filter((key) => state.pendingCartCountDeltas.has(key));
}

function markPendingExternalAddsClosed() {
  unresolvedExternalAddKeys().forEach((key) => state.closedExternalAddKeys.add(key));
}

function shouldOpenExternalAdd(pendingCountKey, requestedOpen = false) {
  if (!requestedOpen) return false;
  if (pendingCountKey && state.closedExternalAddKeys.has(pendingCountKey)) return false;
  return shouldOpenForExternalAdd();
}

function latestPendingExternalAddProduct() {
  const products = unresolvedExternalAddProducts();
  return products[products.length - 1];
}

function restorePendingExternalAddLines() {
  const root = getRoot();
  if (!root || !getDialog()?.open) return;
  unresolvedExternalAddProducts().forEach((product) => appendPendingLine(product));
}

function pruneResolvedExternalAddState() {
  [...state.pendingExternalAddProducts.keys()].forEach((key) => {
    if (!state.pendingCartCountDeltas.has(key)) clearExternalAddPending(key);
  });
}

function quantityFromExternalCartAdd(target, reploAddTarget) {
  const control = reploAddTarget?.control || (target instanceof Element ? target.closest("button, input, [role='button'], [tabindex='0']") : undefined);
  const form =
    reploAddTarget?.form ||
    (target instanceof HTMLFormElement ? target : target.closest("form[action*='/cart/add']"));
  const visibleQuantity = visibleQuantityFromContext(control || target, form);
  if (visibleQuantity !== undefined) return visibleQuantity;

  if (!form) return 1;
  return Number(cartAddPayloadFromForm(form).quantity) || 1;
}

function scheduleExternalCartAddSync(quantity = 1, { open = true, product = {} } = {}) {
  const productQuantity = Math.max(1, Number(quantity) || Number(product.quantity) || 1);
  const pendingCountKey = nextPendingCartCountKey("external-add");
  const pendingProduct = {
    ...product,
    isSubscribable: product.isSubscription ? false : product.isSubscribable,
    pendingCountKey,
    quantity: Number(product.quantity) || productQuantity,
  };
  state.latestExternalAddKey = pendingCountKey;
  if (cleanOptimisticProductTitle(pendingProduct.title)) state.pendingExternalAddProducts.set(pendingCountKey, pendingProduct);
  setOptimisticCartCountDelta(pendingCountKey, productQuantity);

  if (open) {
    appendPendingLine(pendingProduct);
    openCart();
  }

  setExternalAddRefreshTimers(
    pendingCountKey,
    [
      open
        ? window.setTimeout(() => {
            if (shouldOpenExternalAdd(pendingCountKey, open)) appendPendingLine(pendingProduct);
          }, 75)
        : undefined,
      window.setTimeout(() => {
        refresh({
          clearPendingKeys: [pendingCountKey],
          open: shouldOpenExternalAdd(pendingCountKey, open),
        }).catch((error) => console.error("Naomi cart refresh failed", error));
      }, EXTERNAL_ADD_BACKUP_REFRESH_MS),
    ].filter(Boolean),
  );

  return pendingCountKey;
}

function scheduleExternalCartAddCompletionSync({ open = false, pendingCountKey, product = {} } = {}) {
  if (state.internalRequestDepth > 0) return;
  if (!pendingCountKey) {
    window.setTimeout(() => {
      refresh({ open: open && shouldOpenForExternalAdd() }).catch((error) => console.error("Naomi cart refresh failed", error));
    }, EXTERNAL_ADD_FAST_REFRESH_MS);
    return;
  }

  clearExternalAddRefreshTimers(pendingCountKey);
  const pendingProduct = {
    ...(product.title ? product : state.pendingExternalAddProducts.get(pendingCountKey) || {}),
    pendingCountKey,
  };
  const shouldOpen = shouldOpenExternalAdd(pendingCountKey, open);

  if (shouldOpen) {
    appendPendingLine(pendingProduct);
    openCart();
  }

  setExternalAddRefreshTimers(
    pendingCountKey,
    [
      window.setTimeout(() => {
        refresh({
          forceClearPendingKeys: [pendingCountKey],
          open: shouldOpenExternalAdd(pendingCountKey, open),
        }).catch((error) => console.error("Naomi cart refresh failed", error));
      }, EXTERNAL_ADD_FAST_REFRESH_MS),
      window.setTimeout(() => {
        refresh({
          forceClearPendingKeys: [pendingCountKey],
          open: shouldOpenExternalAdd(pendingCountKey, open),
        }).catch((error) => console.error("Naomi cart refresh failed", error));
        clearExternalAddPending(pendingCountKey);
      }, EXTERNAL_ADD_BACKUP_REFRESH_MS),
    ],
  );
}

function observeExternalCartAdd(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (target.closest("[data-naomi-cart-dialog]")) return;

  const reploAddTarget = reploCartAddTargetFromEventTarget(target);
  const submittedAddForm = event.type === "submit" && target instanceof HTMLFormElement && isCartAddForm(target);
  const clickedAddForm = event.type === "click" ? cartAddSubmitControlFromTarget(target) : undefined;
  const isNativeProductForm = Boolean(target.closest("product-form-component"));
  const nativeClickedSubmit = isNativeProductForm && event.type === "click"
    ? target.closest("button[type='submit'], input[type='submit']")
    : undefined;
  const nativeClickedAddForm = nativeClickedSubmit?.closest("form[action*='/cart/add']");
  const addForm = submittedAddForm || clickedAddForm || nativeClickedAddForm;
  const keepClosed = shouldKeepDrawerClosedForExternalAdd(target, reploAddTarget);
  const addControl = nativeClickedSubmit || reploAddTarget?.control || target.closest("button, input, [role='button'], [tabindex='0']");
  const isPdpPurchaseAdd = isFocusedPdpAddControl(addControl, addForm);

  if (keepClosed) markExternalAddNoOpen();
  if (!keepClosed && (addForm || reploAddTarget)) clearManualCartClose();

  if (isNativeProductForm && (!reploAddTarget || isPdpPurchaseAdd)) {
    if (addForm) {
      state.nextCartAddProduct = optimisticProductFromExternalAddTarget(nativeClickedSubmit || addForm, undefined, {
        forceCurrentProduct: isPdpPurchaseAdd,
      });
    }
    return;
  }
  if (isPdpPurchaseAdd) {
    state.nextCartAddProduct = optimisticProductFromExternalAddTarget(addControl || addForm || target, undefined, {
      forceCurrentProduct: true,
    });
    return;
  }
  if (!addForm && !reploAddTarget) return;

  const optimisticProduct = optimisticProductFromExternalAddTarget(target, reploAddTarget);
  const pendingCountKey = scheduleExternalCartAddSync(quantityFromExternalCartAdd(target, reploAddTarget), {
    open: !keepClosed,
    product: optimisticProduct,
  });
  rememberAnticipatedExternalAdd(pendingCountKey, optimisticProduct);
}

function optimisticProductFromCartAddDetails(details = {}) {
  return {
    ...(details.sellingPlan ? { isSubscribable: false, isSubscription: true } : {}),
    sellingPlan: details.sellingPlan,
    variantId: details.variantId,
  };
}

function observeCartAddRequest(quantity = 1, { product, details = {} } = {}) {
  if (state.internalRequestDepth > 0) return;
  const open = shouldOpenForExternalAdd();
  const optimisticProduct = mergeProductContext(
    state.nextCartAddProduct || product || {},
    optimisticProductFromCartAddDetails(details),
  );
  state.nextCartAddProduct = undefined;
  const anticipatedPendingCountKey = consumeAnticipatedExternalAdd(optimisticProduct, quantity);
  if (anticipatedPendingCountKey) return anticipatedPendingCountKey;
  return scheduleExternalCartAddSync(quantity, { open, product: optimisticProduct });
}

function installCartAddRequestObserver() {
  if (window.__naomiCartAddRequestObserverInstalled) return;
  window.__naomiCartAddRequestObserverInstalled = true;

  if (typeof window.fetch === "function") {
    const nativeFetch = window.fetch.bind(window);

    window.fetch = (input, init = {}) => {
      const method = String(init?.method || input?.method || "GET").toUpperCase();
      const isCartAdd = method === "POST" && isCartAddUrl(input);
      const observedInit = isCartAdd ? requestWithCartSections(input, init) : init;
      let pendingCountKey;

      if (isCartAdd) {
        const details = cartAddDetailsFromBody(observedInit.body || init.body);
        pendingCountKey = observeCartAddRequest(details.quantity, { details });
      }

      return nativeFetch(input, observedInit).then((response) => {
        if (isCartAdd && !response.ok) {
          clearExternalAddPending(pendingCountKey, { clearCount: true });
          scheduleRefresh();
        }
        if (isCartAdd && response.ok) {
          const open = shouldOpenExternalAdd(pendingCountKey, true);
          scheduleExternalCartAddCompletionSync({ open, pendingCountKey });
        }

        return response;
      }).catch((error) => {
        clearExternalAddPending(pendingCountKey, { clearCount: true });
        scheduleRefresh();
        throw error;
      });
    };
  }

  if (typeof window.XMLHttpRequest === "function") {
    const NativeXMLHttpRequest = window.XMLHttpRequest;

    window.XMLHttpRequest = function NaomiObservedXMLHttpRequest() {
      const request = new NativeXMLHttpRequest();
      let requestMethod = "GET";
      let requestUrl = "";

      const nativeOpen = request.open;
      request.open = function open(method, url, ...args) {
        requestMethod = String(method || "GET").toUpperCase();
        requestUrl = url;
        return nativeOpen.call(request, method, url, ...args);
      };

      const nativeSend = request.send;
      request.send = function send(body) {
        let pendingCountKey;
        if (requestMethod === "POST" && isCartAddUrl(requestUrl)) {
          const details = cartAddDetailsFromBody(body);
          pendingCountKey = observeCartAddRequest(details.quantity, { details });
          request.addEventListener("load", () => {
            if (request.status >= 200 && request.status < 300) {
              scheduleExternalCartAddCompletionSync({
                open: shouldOpenExternalAdd(pendingCountKey, true),
                pendingCountKey,
              });
            } else {
              clearExternalAddPending(pendingCountKey, { clearCount: true });
              scheduleRefresh();
            }
          });
          request.addEventListener("error", () => {
            clearExternalAddPending(pendingCountKey, { clearCount: true });
            scheduleRefresh();
          });
        }

        return nativeSend.call(request, body);
      };

      return request;
    };
  }
}

async function refresh({
  clearPendingKeys = [],
  clearPendingPrefixes = [],
  forceClearPendingKeys = [],
  forceClearPendingPrefixes = [],
  open = false,
} = {}) {
  if (state.isRefreshing && state.refreshPromise) return state.refreshPromise;
  if (quantityRenderDelay() > 0) {
    scheduleRefresh({ clearPendingKeys, clearPendingPrefixes, forceClearPendingKeys, forceClearPendingPrefixes, open });
    return state.lastCart || shopifyFetch("cart.js");
  }

  state.isRefreshing = true;
  state.refreshPromise = (async () => {
    const cart = await shopifyFetch("cart.js");
    return reconcileCartMutation(cart, {
      clearPendingKeys,
      clearPendingPrefixes,
      forceClearPendingKeys,
      forceClearPendingPrefixes,
      open,
    });
  })();

  try {
    return await state.refreshPromise;
  } finally {
    state.isRefreshing = false;
    state.refreshPromise = undefined;
  }
}

function hasPendingGiftValidationWork() {
  return (
    hasPendingLineChanges() ||
    state.isRefreshing ||
    state.pendingCartCountDeltas.size > 0 ||
    state.pendingExternalAddProducts.size > 0 ||
    state.pendingAnticipatedExternalAdds.length > 0
  );
}

function waitForPendingGiftValidationWork(maxWait = LINE_QUANTITY_INTENT_MAX_AGE_MS + 1000) {
  const startedAt = Date.now();

  return new Promise((resolve) => {
    const check = () => {
      if (!hasPendingGiftValidationWork() || Date.now() - startedAt >= maxWait) {
        resolve();
        return;
      }

      window.setTimeout(check, 50);
    };

    check();
  });
}

function scheduleSilentGiftValidation(delay = 0) {
  window.clearTimeout(state.silentGiftValidationTimer);
  state.silentGiftValidationTimer = window.setTimeout(() => {
    validateGiftsSilently().catch((error) => console.warn("Naomi cart: silent gift validation failed", error));
  }, delay);
}

function cartHasUnresolvedGiftState(root = getRoot()) {
  if (!(root instanceof HTMLElement)) return false;

  const config = getConfig();
  const qualifyingAmount = centsFromDataset(root, "qualifyingSubtotal");
  const cartTotal = centsFromDataset(root, "cartTotal");
  if (!Number.isFinite(qualifyingAmount) || !Number.isFinite(cartTotal)) return false;

  const hatPresent = hasGiftLineInDom("hat", root);
  const scrubPresent = hasGiftLineInDom("scrub", root);
  const hatQualifies = qualifyingAmount >= config.freeGiftThreshold;
  const scrubQualifies = cartTotal >= config.scrubGiftThreshold;

  return (
    (hatPresent && !hatQualifies) ||
    (!hatPresent && hatQualifies && !hasRemovedGift("hat", qualifyingAmount, config)) ||
    (scrubPresent && !scrubQualifies) ||
    (!scrubPresent && scrubQualifies && !hasRemovedGift("scrub", cartTotal, config))
  );
}

async function validateGiftsSilently({ waitForPending = false } = {}) {
  if (state.silentGiftValidationPromise) {
    const existingValidation = await state.silentGiftValidationPromise;
    if (!waitForPending) return existingValidation;
  }

  state.silentGiftValidationPromise = (async () => {
    const attempts = waitForPending ? 2 : 1;

    for (let attempt = 0; attempt < attempts; attempt += 1) {
      if (waitForPending) await waitForPendingGiftValidationWork();

      const mutationSeq = state.cartMutationSeq;
      const cart = await shopifyFetch("cart.js");
      if (mutationSeq !== state.cartMutationSeq || hasPendingGiftValidationWork()) {
        if (attempt + 1 < attempts) continue;
        if (waitForPending) throw new Error("Cart updates did not settle before checkout validation.");
        scheduleSilentGiftValidation(QUANTITY_RENDER_SETTLE_MS);
        return cart;
      }

      const syncedCart = await syncFreeGift(cart);
      if (syncedCart === cart) {
        state.lastCart = cart;
        return cart;
      }

      if (syncedCart?.sections) {
        await renderCartSection(syncedCart.sections);
      } else {
        await renderCartSection();
      }
      dispatchHorizonCartUpdate(syncedCart);
      return syncedCart;
    }

    return undefined;
  })();

  try {
    return await state.silentGiftValidationPromise;
  } finally {
    state.silentGiftValidationPromise = undefined;
  }
}

function ensureScrim() {
  let scrim = document.querySelector(".naomi-cart__scrim");
  if (!scrim) {
    scrim = document.createElement("div");
    scrim.className = "naomi-cart__scrim";
    scrim.setAttribute("aria-hidden", "true");
    document.body?.append(scrim);
  }

  return scrim;
}

function setCartOpenState(isOpen) {
  document.documentElement.toggleAttribute("data-naomi-cart-open", isOpen);
  document.documentElement.removeAttribute("data-naomi-cart-closing");

  if (isOpen) {
    ensureScrim();
  }
}

function mountDialog() {
  const dialog = getDialog();
  if (dialog && document.body && dialog.parentElement !== document.body) {
    document.body.append(dialog);
  }

  ensureScrim();
  return dialog;
}

function startDrawerChoreography(dialog) {
  if (!dialog || prefersReducedMotion()) return;

  window.clearTimeout(state.openingChoreographyTimer);
  window.clearTimeout(state.closingChoreographyTimer);
  dialog.classList.remove("is-opening-choreography");
  dialog.classList.remove("is-closing-choreography");
  dialog.getBoundingClientRect();
  dialog.classList.add("is-opening-choreography");

  state.openingChoreographyTimer = window.setTimeout(() => {
    dialog.classList.remove("is-opening-choreography");
  }, 560);
}

function stopDrawerOpenChoreography(dialog = getDialog()) {
  if (!dialog) return;

  window.clearTimeout(state.openingChoreographyTimer);
  dialog.classList.remove("is-opening-choreography");
}

function startDrawerCloseChoreography(dialog) {
  if (!dialog || prefersReducedMotion()) return;

  window.clearTimeout(state.openingChoreographyTimer);
  window.clearTimeout(state.closingChoreographyTimer);
  dialog.classList.remove("is-opening-choreography");
  dialog.classList.remove("is-closing-choreography");
  dialog.getBoundingClientRect();
  dialog.classList.add("is-closing-choreography");

  state.closingChoreographyTimer = window.setTimeout(() => {
    dialog.classList.remove("is-closing-choreography");
  }, 240);
}

function openCart({ userInitiated = false } = {}) {
  if (userInitiated) {
    clearManualCartClose();
  } else if (!shouldAllowAutomaticOpen()) {
    return;
  }

  const dialog = mountDialog();
  if (!dialog) return;
  moveGiftLinesToBottom();

  const isAlreadyOpen = (
    dialog.open &&
    document.documentElement.hasAttribute("data-naomi-cart-open") &&
    dialog.dataset.naomiCartState !== "closing"
  );
  const shouldResetCarousel = !isAlreadyOpen;

  window.clearTimeout(state.closeTimer);
  dialog.dataset.naomiCartState = isAlreadyOpen ? "open" : "opening";

  if (!dialog.open) {
    if (typeof dialog.show === "function") {
      dialog.show();
    } else {
      dialog.setAttribute("open", "");
    }
  }

  if (shouldResetCarousel) state.carouselInteracted = false;
  setCartOpenState(true);
  if (shouldResetCarousel) startDrawerChoreography(dialog);
  if (shouldResetCarousel) {
    window.requestAnimationFrame?.(() => {
      dialog.dataset.naomiCartState = "open";
    });
    if (!window.requestAnimationFrame) dialog.dataset.naomiCartState = "open";
  }
  initCarousel({ reset: shouldResetCarousel });
  scheduleCartLayoutUpdate();
}

function closeCart({ animate = true } = {}) {
  const dialog = getDialog();
  state.subscriptionInfoOpenedAt = 0;
  document.documentElement.removeAttribute("data-naomi-subscription-info-open");
  clearSubscriptionInfoLayerTimers();
  markManualCartClose();
  markPendingExternalAddsClosed();

  if (dialog?.open) {
    dialog.dataset.naomiCartState = "closing";
    dialog.classList.remove("is-opening-choreography");
    window.clearTimeout(state.openingChoreographyTimer);
    window.clearTimeout(state.closeTimer);

    if (!animate || prefersReducedMotion()) {
      window.clearTimeout(state.closingChoreographyTimer);
      dialog.close();
      dialog.removeAttribute("data-naomi-cart-state");
      dialog.classList.remove("is-closing-choreography");
      setCartOpenState(false);
      state.drawerOpenedAt = 0;
      return;
    }

    startDrawerCloseChoreography(dialog);
    document.documentElement.setAttribute("data-naomi-cart-closing", "");
    state.closeTimer = window.setTimeout(() => {
      if (dialog.dataset.naomiCartState === "closing") {
        dialog.close();
        dialog.removeAttribute("data-naomi-cart-state");
        dialog.classList.remove("is-closing-choreography");
        setCartOpenState(false);
      }
    }, 240);
  } else {
    setCartOpenState(false);
  }

  state.drawerOpenedAt = 0;
}

function elementIsVisible(element) {
  if (!(element instanceof HTMLElement)) return false;

  const style = window.getComputedStyle(element);
  if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return false;

  const rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function activeSubscriptionInfoPopup() {
  return [...document.querySelectorAll("dialog[open], [role='dialog'], [aria-modal='true'], [class*='modal'], [class*='popup']")]
    .find((element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.closest("[data-naomi-cart-dialog]")) return false;
      if (!elementIsVisible(element)) return false;

      return /subscription|subscriptions|cancel anytime|how subscriptions work/i.test(element.textContent || "");
    });
}

function clearSubscriptionInfoLayerTimers() {
  state.subscriptionInfoLayerTimers.forEach((timer) => window.clearTimeout(timer));
  state.subscriptionInfoLayerTimers = [];
}

function clearSubscriptionInfoLayerStateIfClosed() {
  if (!activeSubscriptionInfoPopup()) {
    state.subscriptionInfoOpenedAt = 0;
    document.documentElement.removeAttribute("data-naomi-subscription-info-open");
    clearSubscriptionInfoLayerTimers();
  }
}

function liftSubscriptionInfoPopup() {
  const popup = activeSubscriptionInfoPopup();
  if (!(popup instanceof HTMLElement)) {
    if (Date.now() - state.subscriptionInfoOpenedAt > 1400) clearSubscriptionInfoLayerStateIfClosed();
    return;
  }

  let node = popup;
  while (node && node instanceof HTMLElement && node !== document.body) {
    const style = window.getComputedStyle(node);
    const createsLayer =
      node === popup ||
      style.position !== "static" ||
      style.transform !== "none" ||
      style.filter !== "none" ||
      style.opacity !== "1" ||
      style.isolation === "isolate" ||
      style.contain.includes("paint") ||
      style.willChange.includes("transform");

    if (createsLayer) {
      if (style.position === "static") node.style.position = "relative";
      node.style.zIndex = "2147483002";
      node.dataset.naomiSubscriptionInfoLayer = "true";
    }

    node = node.parentElement;
  }
}

function scheduleSubscriptionInfoLayerLift() {
  clearSubscriptionInfoLayerTimers();
  [0, 60, 180, 420, 900, 1600, 2600].forEach((delay) => {
    state.subscriptionInfoLayerTimers.push(window.setTimeout(liftSubscriptionInfoPopup, delay));
  });
}

function shouldKeepCartOpenForSubscriptionInfo(target) {
  if (!state.subscriptionInfoOpenedAt) return false;
  if (target instanceof Element && target.closest("[data-naomi-cart-dialog]")) return false;
  if (Date.now() - state.subscriptionInfoOpenedAt < 1200) {
    window.setTimeout(clearSubscriptionInfoLayerStateIfClosed, 120);
    window.setTimeout(clearSubscriptionInfoLayerStateIfClosed, 360);
    return true;
  }

  const shouldKeepOpen = Boolean(activeSubscriptionInfoPopup());
  if (shouldKeepOpen) {
    window.setTimeout(clearSubscriptionInfoLayerStateIfClosed, 120);
    window.setTimeout(clearSubscriptionInfoLayerStateIfClosed, 360);
  }

  return shouldKeepOpen;
}

function openSubscriptionInfo() {
  const trigger = [...document.querySelectorAll("button, [role='button'], a")]
    .find((element) => !element.closest("[data-naomi-cart-dialog]") && element.textContent?.trim().toLowerCase() === "subscriptions");

  state.subscriptionInfoOpenedAt = Date.now();
  document.documentElement.setAttribute("data-naomi-subscription-info-open", "");
  scheduleSubscriptionInfoLayerLift();

  if (trigger instanceof HTMLElement) {
    window.setTimeout(() => {
      trigger.click();
      scheduleSubscriptionInfoLayerLift();
    }, 0);
  } else {
    window.location.href = "/pages/subscriptions";
  }
}

function scrollableCartContainerForTarget(target) {
  const dialog = getDialog();
  if (!dialog || !(target instanceof Element) || !dialog.contains(target)) return undefined;

  let node = target;
  while (node && node instanceof Element && node !== dialog) {
    const style = window.getComputedStyle(node);
    const canOverflow = /(auto|scroll|overlay)/.test(style.overflowY);
    if (canOverflow && node.scrollHeight > node.clientHeight + 1) return node;
    node = node.parentElement;
  }

  return undefined;
}

function shouldTrapCartScroll(target, deltaY) {
  const dialog = getDialog();
  if (!dialog?.open || !document.documentElement.hasAttribute("data-naomi-cart-open")) return false;
  if (!(target instanceof Element) || !dialog.contains(target)) return true;
  if (!deltaY) return true;

  const scroller = scrollableCartContainerForTarget(target);
  if (!scroller) return true;

  const canScrollUp = scroller.scrollTop > 0;
  const canScrollDown = scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 1;

  if (deltaY < 0) return !canScrollUp;
  return !canScrollDown;
}

function setActiveRecommendation(container, index, { animate = false } = {}) {
  const cards = [...container.querySelectorAll("[data-naomi-recommendation-card]")];
  const dots = [...container.querySelectorAll("[data-naomi-recommendation-dot]")];
  const activeIndex = Number(container.dataset.activeIndex || 0);
  const safeIndex = ((index % cards.length) + cards.length) % cards.length;
  if (safeIndex === activeIndex) return;

  const isPrevious =
    (safeIndex < activeIndex && !(activeIndex === cards.length - 1 && safeIndex === 0)) ||
    (activeIndex === 0 && safeIndex === cards.length - 1);
  const activeCard = cards[activeIndex];

  window.clearTimeout(container.naomiAnimationTimer);
  container.classList.toggle("is-animating", animate);
  if (animate) {
    container.naomiAnimationTimer = window.setTimeout(() => {
      container.classList.remove("is-animating");
    }, 300);
  }
  container.dataset.direction = isPrevious ? "previous" : "next";
  if (activeCard) {
    activeCard.classList.add("is-exiting");
    activeCard.classList.remove("is-active");
    window.clearTimeout(activeCard.naomiExitTimer);
    activeCard.naomiExitTimer = window.setTimeout(() => activeCard.classList.remove("is-exiting"), 240);
  }

  cards.forEach((card, cardIndex) => {
    if (cardIndex === safeIndex) {
      card.classList.add("is-active");
      card.classList.remove("is-exiting");
    } else if (card !== activeCard) {
      card.classList.remove("is-active", "is-exiting");
    }
  });
  dots.forEach((dot, dotIndex) => {
    dot.classList.toggle("is-active", dotIndex === safeIndex);
    dot.setAttribute("aria-pressed", dotIndex === safeIndex ? "true" : "false");
  });
  container.dataset.activeIndex = String(safeIndex);
}

function advanceRecommendation(container, direction = 1) {
  const activeIndex = Number(container.dataset.activeIndex || 0);
  setActiveRecommendation(container, activeIndex + direction, { animate: true });
}

function resetRecommendationCarousel(container) {
  container.classList.remove("is-animating");
  window.clearTimeout(container.naomiAnimationTimer);
  applyRecommendationIndex(container, 0);
}

function updateRecommendationRewardHeading(root = getRoot()) {
  const recommendations = root?.querySelector("[data-naomi-recommendations]");
  const heading = recommendations?.querySelector(".naomi-cart__recommendation-head span");
  if (!(recommendations instanceof HTMLElement) || !(heading instanceof HTMLElement)) return;
  if (recommendations.classList.contains("naomi-cart__recommendations--pending")) return;

  const config = getConfig();
  const qualifyingSubtotal = centsFromDataset(root, "qualifyingSubtotal");
  const cartTotal = centsFromDataset(root, "cartTotal");
  const scrubGiftAmount = scrubGiftProgressAmount(root, qualifyingSubtotal);
  const defaultHeading = recommendations.classList.contains("naomi-cart__recommendations--empty")
    ? "You may like"
    : "You may also like";

  const addButtons = [...recommendations.querySelectorAll("[data-naomi-cart-add]")];

  const rewardAmountsAfterSingleAdd = (button) => {
    const product = optimisticProductFromAddButton(button);
    const variantId = normalizeId(product.variantId);
    const handle = compactText(product.handle || "");
    const isSubscription = product.isSubscription ? "true" : "false";
    const existingLine = [...root.querySelectorAll(".naomi-cart__line:not(.is-free-gift):not(.is-pending)")].find((line) => {
      if (!(line instanceof HTMLElement)) return false;
      if (line.dataset.isSubscription !== isSubscription) return false;
      if (variantId && normalizeId(line.dataset.variantId) === variantId) return true;
      return Boolean(handle && compactText(line.dataset.productHandle || "") === handle);
    });

    let delta = optimisticPendingLinePrice(product, 1);

    if (existingLine instanceof HTMLElement) {
      const previousFinalPrice = centsFromDataset(existingLine, "lineFinalPrice");
      const currentQuantity = Math.max(0, Number(existingLine.dataset.currentQuantity || existingLine.dataset.confirmedQuantity) || 0);
      const nextFinalPrice = optimisticLineFinalPriceForQuantity(existingLine, currentQuantity + 1, button);
      delta = nextFinalPrice - previousFinalPrice;
    }

    if (!Number.isFinite(delta) || delta <= 0) return undefined;

    return {
      cartTotal: cartTotal + delta,
      qualifyingSubtotal: qualifyingSubtotal + delta,
    };
  };

  const nextTier = rewardTierDefinitions(root, qualifyingSubtotal, config, scrubGiftAmount)
    .find(({ amount, threshold }) => amount < threshold);

  const unlockableTier = nextTier && addButtons.length > 0 && addButtons.every((button) => {
    const nextAmounts = rewardAmountsAfterSingleAdd(button);
    if (!nextAmounts) return false;
    const nextAmount = nextTier.type === "scrub" ? nextAmounts.cartTotal : nextAmounts.qualifyingSubtotal;
    return nextAmount >= nextTier.threshold;
  }) ? nextTier : undefined;

  heading.textContent = unlockableTier?.recommendationLabel || defaultHeading;
}

function initCarousel({ reset = false } = {}) {
  const container = document.querySelector("[data-naomi-recommendations]");
  const cards = container?.querySelectorAll("[data-naomi-recommendation-card]");

  if (!getDialog()?.open || !container || !cards || cards.length <= 1) return;
  if (reset) resetRecommendationCarousel(container);
}

document.addEventListener("click", async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest("[data-naomi-cart-trigger]");
  if (trigger) {
    event.preventDefault();
    openCart({ userInitiated: true });
    refresh().catch((error) => console.error("Naomi cart refresh failed", error));
    return;
  }

  const subscriptionInfo = target.closest("[data-naomi-subscription-info]");
  if (subscriptionInfo) {
    event.preventDefault();
    openSubscriptionInfo();
    return;
  }

  const checkout = target.closest(".naomi-cart__checkout");
  if (checkout instanceof HTMLAnchorElement) {
    const needsValidation =
      hasPendingGiftValidationWork() ||
      cartHasUnresolvedGiftState() ||
      Boolean(state.silentGiftValidationPromise);
    if (!needsValidation) return;

    event.preventDefault();
    if (checkout.dataset.naomiValidatingGift === "true") return;

    const checkoutUrl = checkout.href;
    checkout.dataset.naomiValidatingGift = "true";
    checkout.setAttribute("aria-busy", "true");
    try {
      await validateGiftsSilently({ waitForPending: true });
    } catch (error) {
      console.error("Naomi cart: checkout gift validation failed", error);
    }
    window.location.assign(checkoutUrl);
    return;
  }

  const dialog = getDialog();
  if (dialog?.open && !target.closest("[data-naomi-cart-dialog]")) {
    if (shouldKeepCartOpenForSubscriptionInfo(target)) return;
    closeCart();
    return;
  }

  const closeButton = target.closest("[data-naomi-cart-close]");
  if (closeButton) {
    closeCart();
    return;
  }

  const quantityButton = target.closest("[data-naomi-cart-quantity]");
  if (quantityButton) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (quantityButton.hasAttribute("disabled")) return;
    const nextQuantity = optimisticallySetLineQuantity(quantityButton);
    if (nextQuantity !== undefined) scheduleLineChange(quantityButton, nextQuantity);
    return;
  }

  const sellingPlanButton = target.closest("[data-naomi-cart-selling-plan-button]");
  if (sellingPlanButton) {
    optimisticallySubscribeLine(sellingPlanButton);
    const response = await changeLine(
      sellingPlanButton.dataset.line,
      sellingPlanButton.dataset.quantity,
      sellingPlanButton.dataset.sellingPlan,
      { lineKey: sellingPlanButton.dataset.lineKey },
    );
    await reconcileCartMutation(response);
    return;
  }

  const addButton = target.closest("[data-naomi-cart-add]");
  if (addButton) {
    const pendingCountKey = nextPendingCartCountKey("recommendation-add");
    addButton.textContent = "Added";
    appendPendingLine({
      ...optimisticProductFromAddButton(addButton),
      pendingCountKey,
    });
    setOptimisticCartCountDelta(pendingCountKey, 1);
    try {
      const response = await addVariant(addButton.dataset.variantId, 1);
      await reconcileCartMutation(response, { forceClearPendingKeys: [pendingCountKey] });
    } catch (error) {
      clearOptimisticCartCountDelta(pendingCountKey);
      console.error("Naomi recommendation add failed", error);
      if (addButton.dataset.productUrl) window.location.href = addButton.dataset.productUrl;
    }
    return;
  }

  const dot = target.closest("[data-naomi-recommendation-dot]");
  if (dot) {
    const container = dot.closest("[data-naomi-recommendations]");
    if (!container) return;
    if (container.classList.contains("is-stacked")) return;
    state.carouselInteracted = true;
    setActiveRecommendation(container, Number(dot.dataset.naomiRecommendationDot), { animate: true });
  }
}, true);

document.addEventListener("change", async (event) => {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement)) return;
  if (!target.matches("[data-naomi-cart-selling-plan]")) return;

  const cart = await changeLine(target.dataset.line, target.dataset.quantity, target.value, { lineKey: target.dataset.lineKey });
  await reconcileCartMutation(cart);
});

document.addEventListener(
  "close",
  (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches("[data-naomi-cart-dialog]")) {
      target.removeAttribute("open");
      target.removeAttribute("data-naomi-cart-state");
      target.classList.remove("is-opening-choreography", "is-closing-choreography");
      window.clearTimeout(state.openingChoreographyTimer);
      window.clearTimeout(state.closingChoreographyTimer);
      setCartOpenState(false);
      state.drawerOpenedAt = 0;
    } else if (state.subscriptionInfoOpenedAt) {
      window.setTimeout(clearSubscriptionInfoLayerStateIfClosed, 60);
    }
  },
  true,
);

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && getDialog()?.open) {
    if (state.subscriptionInfoOpenedAt && activeSubscriptionInfoPopup()) return;
    event.preventDefault();
    closeCart();
  }
});

document.addEventListener("click", observeExternalCartAdd, true);
document.addEventListener("submit", observeExternalCartAdd, true);
document.addEventListener("pointerenter", (event) => {
  if (event.target instanceof Element && event.target.closest("[data-naomi-cart-trigger]")) schedulePrewarmCart();
}, true);
document.addEventListener("focusin", (event) => {
  if (event.target instanceof Element && event.target.closest("[data-naomi-cart-trigger]")) schedulePrewarmCart();
});
document.addEventListener("touchstart", (event) => {
  if (event.target instanceof Element && event.target.closest("[data-naomi-cart-trigger]")) schedulePrewarmCart();
}, { passive: true });

document.addEventListener("cart:update", (event) => {
  if (state.isRefreshing) return;
  if (event.detail?.sourceId === "naomi-cart" || event.detail?.data?.source === "naomi-cart") return;

  const pendingKey = state.latestExternalAddKey;
  const shouldOpen =
    event.detail?.data?.source === "product-form-component" &&
    event.detail?.data?.didError !== true &&
    shouldOpenExternalAdd(pendingKey, true);
  if (shouldOpen) {
    appendPendingLine(state.nextCartAddProduct || latestPendingExternalAddProduct() || {});
    state.nextCartAddProduct = undefined;
    openCart();
  }

  scheduleRefresh();
  window.queueMicrotask?.(() => renderHeaderCartCount());
  if (!window.queueMicrotask) window.setTimeout(() => renderHeaderCartCount(), 0);
});

document.addEventListener(
  "wheel",
  (event) => {
    if (shouldTrapCartScroll(event.target, event.deltaY)) event.preventDefault();
  },
  { passive: false },
);

document.addEventListener(
  "scroll",
  (event) => {
    if (event.target instanceof HTMLElement && event.target.classList.contains("naomi-cart__items")) {
      updateCartItemsScrollState(event.target);
    }
  },
  true,
);

document.addEventListener(
  "touchstart",
  (event) => {
    if (!getDialog()?.open || !document.documentElement.hasAttribute("data-naomi-cart-open")) return;
    const touch = event.changedTouches[0];
    state.cartTouchStartX = touch?.clientX;
    state.cartTouchStartY = touch?.clientY;
    state.cartTouchLastY = touch?.clientY;
  },
  { passive: true },
);

document.addEventListener(
  "touchmove",
  (event) => {
    if (!getDialog()?.open || !document.documentElement.hasAttribute("data-naomi-cart-open")) return;

    const touch = event.changedTouches[0];
    if (!touch) return;

    const startX = state.cartTouchStartX ?? touch.clientX;
    const startY = state.cartTouchStartY ?? touch.clientY;
    const deltaX = touch.clientX - startX;
    const totalDeltaY = touch.clientY - startY;
    const deltaY = (state.cartTouchLastY ?? touch.clientY) - touch.clientY;
    state.cartTouchLastY = touch.clientY;

    if (Math.abs(deltaX) > Math.abs(totalDeltaY)) return;
    if (shouldTrapCartScroll(event.target, deltaY)) event.preventDefault();
  },
  { passive: false },
);

document.addEventListener(
  "touchend",
  () => {
    state.cartTouchStartX = undefined;
    state.cartTouchStartY = undefined;
    state.cartTouchLastY = undefined;
  },
  { passive: true },
);

document.addEventListener("touchstart", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const container = target.closest("[data-naomi-recommendations]");
  if (!container || container.classList.contains("is-stacked")) return;
  state.touchStartX = event.changedTouches[0]?.clientX;
});

document.addEventListener("touchend", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const container = target.closest("[data-naomi-recommendations]");
  if (!container || container.classList.contains("is-stacked") || state.touchStartX === undefined) return;

  const deltaX = event.changedTouches[0].clientX - state.touchStartX;
  state.touchStartX = undefined;

  if (Math.abs(deltaX) < 40) return;
  state.carouselInteracted = true;
  advanceRecommendation(container, deltaX < 0 ? 1 : -1);
});

function initNaomiCart() {
  document.documentElement.dataset.naomiCartReady = "true";
  state.confirmedItemCount = confirmedItemCountFromDom();
  const config = getConfig();
  const currentQualifyingSubtotal = centsFromDataset(getRoot(), "qualifyingSubtotal");
  const currentCartTotal = centsFromDataset(getRoot(), "cartTotal");
  state.wasBelowGiftThreshold = currentQualifyingSubtotal < config.freeGiftThreshold;
  state.wasBelowScrubGiftThreshold = currentCartTotal < config.scrubGiftThreshold;
  installCartAddRequestObserver();

  const dialog = getDialog();
  if (dialog?.open) {
    dialog.close();
  }
  setCartOpenState(false);

  moveGiftLinesToBottom();
  window.NaomiCart = {
    addVariant: async ({ properties, quantity = 1, variantId }) => {
      const pendingCountKey = nextPendingCartCountKey("api-add");
      appendPendingLine({ pendingCountKey });
      openCart();
      setOptimisticCartCountDelta(pendingCountKey, Number(quantity) || 1);
      try {
        const response = await addVariant(variantId, quantity, properties);
        return reconcileCartMutation(response, { forceClearPendingKeys: [pendingCountKey], open: true });
      } catch (error) {
        clearOptimisticCartCountDelta(pendingCountKey);
        throw error;
      }
    },
    changeLine: async ({ giftType = "hat", isFreeGift, lineIndex, quantity, sellingPlanId }) => {
      const cart = await changeLine(lineIndex, quantity, sellingPlanId);
      if (isFreeGift && quantity === 0) setRemovedGift(giftType, true, cart);
      return reconcileCartMutation(cart);
    },
    open: openCart,
    refresh,
    refreshAndOpen: () => {
      openCart();
      return refresh();
    },
    syncFreeGift: refresh,
  };

  syncRewardStateForActiveCurrency();
  updateRecommendationRewardHeading();
  initCarousel();
  scheduleCartLayoutUpdate();
  if (cartHasUnresolvedGiftState()) scheduleSilentGiftValidation(250);
}

window.addEventListener("resize", scheduleCartLayoutUpdate);
window.visualViewport?.addEventListener("resize", scheduleOpenCartLayoutUpdate, { passive: true });
window.visualViewport?.addEventListener("scroll", scheduleOpenCartLayoutUpdate, { passive: true });

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initNaomiCart);
} else {
  initNaomiCart();
}
